export const singleNext = {
    "type": "singlenext",
    "text": "Our records show that your primary care provider is [Lawrence Garber].",
    "AsyncHBID": "hqZcRC6gYlJd1VNvO3kFV-us",
    "hostName": "bb05ae0bdf0ed9980b7d4dbd1915cf9feabb01da36b9219ac8f0716a37cfb8f9",
    "buttons": [
        {
            "displayText": "Next",
            "value": "Next",
            "type": "postBack"
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "subHeaderText": "If this is not correct, please select a different provider.",
            "current_step": "medical_history",
            "question_id": "MedicalHistory",
            "version": "2.7.0-dev.2",
            "cdoName": "OptumIncubator"
        },
        [
            {
                "displayText": "Lawrence Garber",
                "value": "Lawrence Garber",
                "selected": true
            },
            {
                "displayText": "Wendy Bergman",
                "value": "Wendy Bergman",
                "selected": false
            },
            {
                "displayText": "My primary care provider is not listed",
                "value": "Not Listed",
                "selected": false
            }
        ]
    ],
    "id": 2533
}

export const testMsg =
{
    "type": "message",
    "id": "5htIVXR6GIqIvxk0y9ZQdm-us|0000059",
    "timestamp": "2022-05-12T15:19:38.56796Z",
    "channelId": "directline",
    "from": {
        "id": "asynchronous-care-nonprod-xsm0m9l",
        "name": "asynchronous-care-nonprod"
    },
    "conversation": {
        "id": "5htIVXR6GIqIvxk0y9ZQdm-us"
    },
    "text": "{\"type\":\"summary\",\"text\":\"\",\"AsyncHBID\":\"5htIVXR6GIqIvxk0y9ZQdm-us\",\"language\":\"english\",\"buttons\":[],\"hyperlinks\":[],\"attachments\":{\"images\":[]},\"data\":[{\"current_step\":\"triage_complete\",\"triage\":\"consultation\",\"channel\":\"personal_visit\",\"final_triage\":\"primary_care\",\"FormatCode\":\"Reliant\",\"hasSlots\":false},{\"triage_level\":\"primary_care\",\"qna\":[{\"id\":[\"p_359\"],\"question\":\"What is your COVID-19 vaccination status?\",\"answer\":\"Fully vaccinated plus booster shot, with the last dose received at least 2 weeks ago\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_105\"],\"question\":\"How would you describe the cough?\",\"answer\":\"Dry cough, without phlegm or mucus\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_478\"],\"question\":\"Do you have pain in any part of your face?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"p_82\"],\"question\":\"Have you recently had contact with something you may be allergic to, e.g., food, chemicals, pollen, pets, etc.?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_252\"],\"question\":\"Is your nose or throat itchy or tingly?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"p_83\"],\"question\":\"Do you have a weakened immune system, e.g., you are HIV positive, taking oral or intravenous steroids or chemotherapy, using insulin, or had your spleen removed?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_2375\"],\"question\":\"What is the oxygen saturation level of your blood as recorded by a pulse oximeter?\",\"answer\":\"It wasn't measured\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_1547\"],\"question\":\"Has the fatigue lasted more than 6 months?\",\"answer\":\"Yes\",\"type\":\"single\",\"evidence\":\"present\"},{\"id\":[\"s_98\"],\"question\":\"Do you have a fever?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_538\"],\"question\":\"Have your muscles been trembling?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1332\"],\"question\":\"Do you feel weaker than usual after exercising?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1985\"],\"question\":\"Do you have a cough during the night that sometimes wakes you up?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1104\"],\"question\":\"Do you breathe more often through the mouth than the nose?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_700\"],\"question\":\"Is any part of your body swollen?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1924\"],\"question\":\"Do you have sudden, severe coughing attacks making it hard to breathe?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_2251\"],\"question\":\"What is your heart rate, i.e., how fast does your heart beat?\",\"answer\":\"It wasn't measured\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_120\"],\"question\":\"Do you feel anxious or fearful?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_671\"],\"question\":\"Are the veins in your neck swollen or thickened?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"}],\"chief_complaints\":[\"Cough\"],\"secondary_complaints\":[\"Cough lasting more than 8 weeks\",\"Fatigue\"],\"serious_symptoms\":[],\"possible_causes\":[{\"id\":\"c_76\",\"name\":\"Chronic obstructive pulmonary disease\",\"common_name\":\"Chronic obstructive pulmonary disease\",\"sex_filter\":\"both\",\"categories\":[\"Pulmonology\"],\"prevalence\":\"moderate\",\"acuteness\":\"chronic_with_exacerbations\",\"severity\":\"moderate\",\"extras\":{\"icd10_code\":\"J44, J44.8, J44.9\",\"hint\":\"Please consult a general practitioner or a pulmonologist.\"},\"triage_level\":\"consultation\",\"recommended_channel\":\"personal_visit\",\"probability\":0.3366,\"possible_cause\":\"Chronic obstructive pulmonary disease\",\"brief_summary\":\"A condition where the airways of the bronchial tree are weakened by chronic inflammation and there is loss of the small lung units called alveoli needed to bring oxygen into blood and remove carbon dioxide from the blood  \",\"complete_summary\":\"COPD is a term for a group of respiratory diseases that cause shortness of breath and cough related to chronic inflammation and narrowing of the airways of the lung.  COPD stands for Chronic Obstructive Pulmonary Disease.  When airways are narrowed, difficulty breathing is often greatest during exhalation.  COPD is usually related to smoking but may be caused by other exposures.  Genetics play a role in some cases of COPD.  The Possible Cause is usually confirmed by pulmonary function testing where lung function is measured and compared to normal predicted values.  Treatment often includes medications that dilate airways (bronchodilators).  Smoking cessation is essential to prevent the problem from getting worse.\",\"self_care_advice\":\"- If you smoke, talk to your doctor about getting help to quit.  Several medications are available that have been shown to increase your chance of quitting successfully.  \\r\\n- Do your best to avoid contracting a respiratory infection.  Avoid places where people congregate, particularly during winter months when respiratory viruses are more prevalent.\\r\\n- Get a flu shot every year.\\r\\n- Wash your hands frequently to reduce your chance of acquiring an infection.\\r\\n- Try to stay in shape by getting some exercise every day.  Take your medications as directed.\",\"see_provider\":\"Call your healthcare provider if you have COPD and experience increased shortness of breath not responding to usual inhalers.\"},{\"id\":\"c_269\",\"name\":\"Chronic sinusitis\",\"common_name\":\"Chronic sinusitis\",\"sex_filter\":\"both\",\"categories\":[\"Otorhinolaryngology\"],\"prevalence\":\"moderate\",\"acuteness\":\"chronic\",\"severity\":\"mild\",\"extras\":{\"icd10_code\":\"J32, J32.1, J32.2, J32.3, J32.4, J32.8, J32.9\",\"hint\":\"Please consult a family doctor or an otolaryngologist.\"},\"triage_level\":\"consultation\",\"recommended_channel\":\"personal_visit\",\"probability\":0.1453,\"possible_cause\":\"Chronic sinusitis\",\"brief_summary\":\"Chronic inflammation of the sinuses over three months duration\",\"complete_summary\":\"Chronic sinusitis is caused by ongoing infections, by growths in the sinuses (nasal polyps) or swelling of the lining of your sinuses.<br><br>Symptoms are typically present for more than 12 weeks.<br><br>\\r\\nSigns/symptoms:<br>\\r\\n- Nasal pain\\r\\n- Thick, yellow or green discharge from the nose\\r\\n- postnasal drip\\r\\n- difficulty breathing through your nose\\r\\n- Pain, tenderness and swelling around your eyes, cheeks, nose or forehead\\r\\n- Reduced sense of smell and taste\",\"self_care_advice\":\"Treatment options at home include:<br>\\r\\n- Nasal corticosteroids. These nasal sprays help inflammation. Examples include fluticasone, triamcinolone, budesonide\\r\\n- Saline nasal irrigation, with nasal sprays or solutions, rinses away irritants and drainage\",\"see_provider\":\"Seek medical advie if:\\r\\n- You've had multiple sinus infections and it is not responding to treatment\\r\\n- sinus symptoms lasting longer than 10 days\\r\\n- Your symptoms don't improve or suddenly return\"},{\"id\":\"c_144\",\"name\":\"Sjögren's syndrome\",\"common_name\":\"Sjögren's syndrome\",\"sex_filter\":\"both\",\"categories\":[\"Rheumatology\"],\"prevalence\":\"very_rare\",\"acuteness\":\"chronic\",\"severity\":\"mild\",\"extras\":{\"icd10_code\":\"M35.0\",\"hint\":\"Please consult a rheumatologist.\"},\"triage_level\":\"consultation\",\"recommended_channel\":\"personal_visit\",\"probability\":0.1153,\"possible_cause\":\"Sjogren's syndrome\",\"brief_summary\":\"Sjogrens syndrome is an autoimmune disease that causes dry mouth and dry eyes.\",\"complete_summary\":\"The main symptoms include:<br>\\r\\n- Dry eyes. Your eyes may burn, itch or feel gritty\\r\\n- Dry mouth\\r\\n<br><br>\\r\\nOther symptoms include:<br>\\r\\n- dry, itchy skin\\r\\n- joint pain\\r\\n- trouble urinating, pain with urination or urgent need to urinate\\r\\n- tiredness\\r\\n- vaginal dryness\\r\\n<br><br>\\r\\nRisk factors include:<br>\\r\\n- age, typically diagnosed after 40\\r\\n- sex, more prevalent in women\\r\\n- other rheumatic diseases such as rheumatoid arthritis, lupus\",\"self_care_advice\":\"Sjogren's syndrome is a lifelong illness that is managed by healthcare providers and specialists with a wide variety of treatments.<br><br>It can be difficult to diagnose because there is a wide range of symptoms people experience and this can be related to other diseases. Side effects of certain medications also mimic some symptoms of Sjogren's syndrome.<br><br>\\r\\nLifestyle changes that may help with symptoms:<br>\\r\\n- artificial tears for dry eyes\\r\\n- increase humidity\\r\\n- increase fluid intake\\r\\n- avoid smoking\\r\\n- stimulation of saliva flow with sugarless gum or citrus-flavored hard candies\\r\\n- seek dental care regularly, as dry mouth places you at higher risk for dental caries\\r\\n- brush teeth regularly\",\"see_provider\":\"If you feel you have symptoms of sjogrens syndrome, contact your healthcare provider to discuss your symptoms further.  You may eventually be set up to see a specialist, such as a rheumatologist.  \"}],\"present_risk_factors\":[\"Hypertension\"],\"care_options\":[\"doctor_visit\",\"urgent_care\"],\"denials\":[\"Facial pain\",\"Contact with allergen\",\"Itching nose or throat\",\"Compromised immune system\",\"Fever\",\"Tremors\",\"Fatigue, weakness after exercise\",\"Cough, nocturnal\",\"Mouth breathing\",\"Edema\",\"Cough, paroxysmal\",\"Anxiety\",\"Neck vein distention\"],\"patient_comment\":\"N/A\",\"age\":80,\"gender\":\"Male\",\"teleconsultation_applicable\":false},[\"I will try self-care\",\"Contact me within two business days\",\"I will schedule an in-person appointment\",\"I will go to ReadyMED / urgent care\",\"I will go to the emergency room\",\"I will call 9-1-1\"],{\"triage_level\":\"consultation\",\"serious\":[],\"root_cause\":\"consultation_condition_likely\",\"teleconsultation_applicable\":false},{\"type\":\"phoneNumberCard\",\"text\":\"Select a phone number below for our care team to reach you at:\",\"buttons\":[],\"hyperlinks\":[],\"attachments\":{\"images\":[]},\"data\":[]}]}",
    "speak": "{\"type\":\"summary\",\"text\":\"\",\"AsyncHBID\":\"5htIVXR6GIqIvxk0y9ZQdm-us\",\"language\":\"english\",\"buttons\":[],\"hyperlinks\":[],\"attachments\":{\"images\":[]},\"data\":[{\"current_step\":\"triage_complete\",\"triage\":\"consultation\",\"channel\":\"personal_visit\",\"final_triage\":\"primary_care\",\"FormatCode\":\"Reliant\",\"hasSlots\":false},{\"triage_level\":\"primary_care\",\"qna\":[{\"id\":[\"p_359\"],\"question\":\"What is your COVID-19 vaccination status?\",\"answer\":\"Fully vaccinated plus booster shot, with the last dose received at least 2 weeks ago\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_105\"],\"question\":\"How would you describe the cough?\",\"answer\":\"Dry cough, without phlegm or mucus\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_478\"],\"question\":\"Do you have pain in any part of your face?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"p_82\"],\"question\":\"Have you recently had contact with something you may be allergic to, e.g., food, chemicals, pollen, pets, etc.?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_252\"],\"question\":\"Is your nose or throat itchy or tingly?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"p_83\"],\"question\":\"Do you have a weakened immune system, e.g., you are HIV positive, taking oral or intravenous steroids or chemotherapy, using insulin, or had your spleen removed?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_2375\"],\"question\":\"What is the oxygen saturation level of your blood as recorded by a pulse oximeter?\",\"answer\":\"It wasn't measured\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_1547\"],\"question\":\"Has the fatigue lasted more than 6 months?\",\"answer\":\"Yes\",\"type\":\"single\",\"evidence\":\"present\"},{\"id\":[\"s_98\"],\"question\":\"Do you have a fever?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_538\"],\"question\":\"Have your muscles been trembling?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1332\"],\"question\":\"Do you feel weaker than usual after exercising?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1985\"],\"question\":\"Do you have a cough during the night that sometimes wakes you up?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1104\"],\"question\":\"Do you breathe more often through the mouth than the nose?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_700\"],\"question\":\"Is any part of your body swollen?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_1924\"],\"question\":\"Do you have sudden, severe coughing attacks making it hard to breathe?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_2251\"],\"question\":\"What is your heart rate, i.e., how fast does your heart beat?\",\"answer\":\"It wasn't measured\",\"type\":\"group_single\",\"evidence\":\"present\"},{\"id\":[\"s_120\"],\"question\":\"Do you feel anxious or fearful?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"},{\"id\":[\"s_671\"],\"question\":\"Are the veins in your neck swollen or thickened?\",\"answer\":\"No\",\"type\":\"single\",\"evidence\":\"absent\"}],\"chief_complaints\":[\"Cough\"],\"secondary_complaints\":[\"Cough lasting more than 8 weeks\",\"Fatigue\"],\"serious_symptoms\":[],\"possible_causes\":[{\"id\":\"c_76\",\"name\":\"Chronic obstructive pulmonary disease\",\"common_name\":\"Chronic obstructive pulmonary disease\",\"sex_filter\":\"both\",\"categories\":[\"Pulmonology\"],\"prevalence\":\"moderate\",\"acuteness\":\"chronic_with_exacerbations\",\"severity\":\"moderate\",\"extras\":{\"icd10_code\":\"J44, J44.8, J44.9\",\"hint\":\"Please consult a general practitioner or a pulmonologist.\"},\"triage_level\":\"consultation\",\"recommended_channel\":\"personal_visit\",\"probability\":0.3366,\"possible_cause\":\"Chronic obstructive pulmonary disease\",\"brief_summary\":\"A condition where the airways of the bronchial tree are weakened by chronic inflammation and there is loss of the small lung units called alveoli needed to bring oxygen into blood and remove carbon dioxide from the blood  \",\"complete_summary\":\"COPD is a term for a group of respiratory diseases that cause shortness of breath and cough related to chronic inflammation and narrowing of the airways of the lung.  COPD stands for Chronic Obstructive Pulmonary Disease.  When airways are narrowed, difficulty breathing is often greatest during exhalation.  COPD is usually related to smoking but may be caused by other exposures.  Genetics play a role in some cases of COPD.  The Possible Cause is usually confirmed by pulmonary function testing where lung function is measured and compared to normal predicted values.  Treatment often includes medications that dilate airways (bronchodilators).  Smoking cessation is essential to prevent the problem from getting worse.\",\"self_care_advice\":\"- If you smoke, talk to your doctor about getting help to quit.  Several medications are available that have been shown to increase your chance of quitting successfully.  \\r\\n- Do your best to avoid contracting a respiratory infection.  Avoid places where people congregate, particularly during winter months when respiratory viruses are more prevalent.\\r\\n- Get a flu shot every year.\\r\\n- Wash your hands frequently to reduce your chance of acquiring an infection.\\r\\n- Try to stay in shape by getting some exercise every day.  Take your medications as directed.\",\"see_provider\":\"Call your healthcare provider if you have COPD and experience increased shortness of breath not responding to usual inhalers.\"},{\"id\":\"c_269\",\"name\":\"Chronic sinusitis\",\"common_name\":\"Chronic sinusitis\",\"sex_filter\":\"both\",\"categories\":[\"Otorhinolaryngology\"],\"prevalence\":\"moderate\",\"acuteness\":\"chronic\",\"severity\":\"mild\",\"extras\":{\"icd10_code\":\"J32, J32.1, J32.2, J32.3, J32.4, J32.8, J32.9\",\"hint\":\"Please consult a family doctor or an otolaryngologist.\"},\"triage_level\":\"consultation\",\"recommended_channel\":\"personal_visit\",\"probability\":0.1453,\"possible_cause\":\"Chronic sinusitis\",\"brief_summary\":\"Chronic inflammation of the sinuses over three months duration\",\"complete_summary\":\"Chronic sinusitis is caused by ongoing infections, by growths in the sinuses (nasal polyps) or swelling of the lining of your sinuses.<br><br>Symptoms are typically present for more than 12 weeks.<br><br>\\r\\nSigns/symptoms:<br>\\r\\n- Nasal pain\\r\\n- Thick, yellow or green discharge from the nose\\r\\n- postnasal drip\\r\\n- difficulty breathing through your nose\\r\\n- Pain, tenderness and swelling around your eyes, cheeks, nose or forehead\\r\\n- Reduced sense of smell and taste\",\"self_care_advice\":\"Treatment options at home include:<br>\\r\\n- Nasal corticosteroids. These nasal sprays help inflammation. Examples include fluticasone, triamcinolone, budesonide\\r\\n- Saline nasal irrigation, with nasal sprays or solutions, rinses away irritants and drainage\",\"see_provider\":\"Seek medical advie if:\\r\\n- You've had multiple sinus infections and it is not responding to treatment\\r\\n- sinus symptoms lasting longer than 10 days\\r\\n- Your symptoms don't improve or suddenly return\"},{\"id\":\"c_144\",\"name\":\"Sjögren's syndrome\",\"common_name\":\"Sjögren's syndrome\",\"sex_filter\":\"both\",\"categories\":[\"Rheumatology\"],\"prevalence\":\"very_rare\",\"acuteness\":\"chronic\",\"severity\":\"mild\",\"extras\":{\"icd10_code\":\"M35.0\",\"hint\":\"Please consult a rheumatologist.\"},\"triage_level\":\"consultation\",\"recommended_channel\":\"personal_visit\",\"probability\":0.1153,\"possible_cause\":\"Sjogren's syndrome\",\"brief_summary\":\"Sjogrens syndrome is an autoimmune disease that causes dry mouth and dry eyes.\",\"complete_summary\":\"The main symptoms include:<br>\\r\\n- Dry eyes. Your eyes may burn, itch or feel gritty\\r\\n- Dry mouth\\r\\n<br><br>\\r\\nOther symptoms include:<br>\\r\\n- dry, itchy skin\\r\\n- joint pain\\r\\n- trouble urinating, pain with urination or urgent need to urinate\\r\\n- tiredness\\r\\n- vaginal dryness\\r\\n<br><br>\\r\\nRisk factors include:<br>\\r\\n- age, typically diagnosed after 40\\r\\n- sex, more prevalent in women\\r\\n- other rheumatic diseases such as rheumatoid arthritis, lupus\",\"self_care_advice\":\"Sjogren's syndrome is a lifelong illness that is managed by healthcare providers and specialists with a wide variety of treatments.<br><br>It can be difficult to diagnose because there is a wide range of symptoms people experience and this can be related to other diseases. Side effects of certain medications also mimic some symptoms of Sjogren's syndrome.<br><br>\\r\\nLifestyle changes that may help with symptoms:<br>\\r\\n- artificial tears for dry eyes\\r\\n- increase humidity\\r\\n- increase fluid intake\\r\\n- avoid smoking\\r\\n- stimulation of saliva flow with sugarless gum or citrus-flavored hard candies\\r\\n- seek dental care regularly, as dry mouth places you at higher risk for dental caries\\r\\n- brush teeth regularly\",\"see_provider\":\"If you feel you have symptoms of sjogrens syndrome, contact your healthcare provider to discuss your symptoms further.  You may eventually be set up to see a specialist, such as a rheumatologist.  \"}],\"present_risk_factors\":[\"Hypertension\"],\"care_options\":[\"doctor_visit\",\"urgent_care\"],\"denials\":[\"Facial pain\",\"Contact with allergen\",\"Itching nose or throat\",\"Compromised immune system\",\"Fever\",\"Tremors\",\"Fatigue, weakness after exercise\",\"Cough, nocturnal\",\"Mouth breathing\",\"Edema\",\"Cough, paroxysmal\",\"Anxiety\",\"Neck vein distention\"],\"patient_comment\":\"N/A\",\"age\":80,\"gender\":\"Male\",\"teleconsultation_applicable\":false},[\"I will try self-care\",\"Contact me within two business days\",\"I will schedule an in-person appointment\",\"I will go to ReadyMED / urgent care\",\"I will go to the emergency room\",\"I will call 9-1-1\"],{\"triage_level\":\"consultation\",\"serious\":[],\"root_cause\":\"consultation_condition_likely\",\"teleconsultation_applicable\":false},{\"type\":\"phoneNumberCard\",\"text\":\"Select a phone number below for our care team to reach you at:\",\"buttons\":[],\"hyperlinks\":[],\"attachments\":{\"images\":[]},\"data\":[]}]}",
    "inputHint": "expectingInput",
    "replyToId": "5htIVXR6GIqIvxk0y9ZQdm-us|0000057"
}

export const thankyou = 
{
    "type": "ThankYou",
    "text": "Thank you for using the symptom checker.",
    "AsyncHBID": "L7ftN7ItCWR6EDHexe0PBm-us",
    "language": "",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "question_id": "ThankYou",
            "headerText": "Thank you!",
            "subHeaderText": "",
            "current_step": "thankyou",
            "version": "2.1.0-dev.25",
            "cdoName": "OptumIncubator"
        }
    ],
    "id": 16
}

export const infotest = {
    "id": 7,
    "type": "prompt",
    "text": "What is your COVID-19 vaccination status?",
    "buttons": [
        {
            "displayText": "Fully vaccinated plus booster shot, with the last dose received at least 2 weeks ago",
            "value": "0",
            "explication": "A booster shot is additional dose of COVID-19 vaccine. It is given to improve protection provided by previous vaccination. It is a third dose in 2-dose series, like the Pfizer-BioNTech or Moderna vaccines, or a second donse in single-dose vaccine, such as the J&J/Janssen vaccine.",
            "instructions": null,
            "type": "postBack"
        }
        ,
        {
            "displayText": "Fully vaccinated, with the last dose received at least 2 weeks ago",
            "value": "1",
            "explication": "One is considered to be fully vaccinated 2 weeks after their second dose in a 2-dose series, such as the Pfizer-BioNTech or Moderna vaccines, or 2 weeks after a single-dose vaccine, such as the J&J/Janssen vaccine.",
            "instructions": null,
            "type": "postBack"
        },
        {
            "displayText": "Partially vaccinated or the last dose less than 2 weeks ago",
            "value": "2",
            "explication": "One is considered to be fully vaccinated 2 weeks after the second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine.",
            "instructions": null,
            "type": "postBack"
        },
        {
            "displayText": "Not vaccinated",
            "value": "3",
            "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
            "instructions": null,
            "type": "postBack"
        }
    ],
    "data": [
        {
            "question_id": "Interview_0",
            "explication": null,
            "instruction": null,
            "rationale": ""
        }
    ]
}

export const disclaimer = {
    "type": "disclaimer",
    "text": "**If you are experiencing an emergency, call 911.** \r\n\r\nThe purpose of this symptom checker is to help you navigate and find care for your symptoms. This tool does not replace any medical advice, diagnosis, or treatment received from a medical professional. \r\n\r\nBy continuing, you are agreeing to our [Terms of Use](https://reliantmedicalgroup.org/pdfs/Terms_of_Use.pdf) and our [Privacy Policy](https://reliantmedicalgroup.org/pdfs/privacy.pdf).",
    "id": 3,
    "buttons": [
        {
            "displayText": "I agree",
            "value": "I agree",
            "type": "postBack"
        }
    ],
    "data": [
        {
            "credits": "This symptom checker is powered by Infermedica.",
            "question_id": "Disclaimer",
            "current_step": "disclaimer"
        }
    ]
}

export const disclaimernew=
{
    "type": "disclaimerNew",
    "text": "",
    "AsyncHBID": "4e957dd0-055e-11f0-ba4f-af77deced390",
    "buttons": [
        {
            "displayText": "Agree and continue",
            "value": "Agree",
            "type": "postBack"
        },
        {
            "displayText": "Cancel",
            "value": "Cancel",
            "type": "postBack"
        }
    ],
    "hostName": "InstanceIdNotSet",
    "attachments": {
        "images": []
    },
    "hyperlinks": [],
    "data": [
        {
            "question_id": "Disclaimer",
            "current_step": "disclaimer",
            "headerText": "Your Symptom Smart™ responses will be stored in MyChart",
            "subHeaderText": "By continuing, you agree and acknowledge that your responses will be added to your MyChart record and shared with your healthcare provider to keep your health information current.",
            "myChartLink": "https://epicpnwmychartnp.optum.com/MyChartWPOC/Home",
            "version": "2.8.0.29",
            "cdoName": "NWest"
        }
    ]
}

export const confirmVirtual =
{
    "type": "confirmVirtual",
    "id": 3,
    "language": "en_us",
    "text": "Confirm that you meet all of the following criteria in order to schedule a virtual care visit",
    "AsyncHBID": "05178e10-9fcb-11ec-9e0a-1ba64661d563|livechat",
    "buttons": [
        {
            "displayText": "Confirm",
            "value": "Confirm",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Schedule an Appointment - Schedule My Virtual Care Visit"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "hasSlots": true,
            "noSlotsHeaderText": 'We apologize, there are no virtual appointments available at this time.',
            "noSlotsBody": 'Additional appointments become available every Monday - Friday at 8 AM. To learn more call (508) 368 - 7890.',

            "question_id": "ConfirmVirtual",
            "headerText": "Confirm that you meet all of the following criteria in order to schedule a virtual care visit",
            "subHeaderText": "To select a different treatment option click cancel.",
            "onCancel": "summary",
            "steps": [
                {
                    "step": "Step 1",
                    "title": "Treatable Conditions",
                    "text": "The Virtual Care Team **does not** treat illnesses and injuries related to:\n* Workman's compensation\n* Motor vehicle accidents\n\n* Serious conditions such as chest pain, shortness of breath, allergic reactions, and active bleeding.\n\n[View the complete list of excluded and treatable conditions](https://reliantmedicalgroup.org/virtual-care-team/virtual-care-team-list-of-conditions-treated/#exclusions)",
                    "checkbox": "My illness or injury is not related to any of the situations listed above."
                },
                {
                    "step": "Step 2",
                    "title": "Location",
                    "text": "To schedule a virtual care visit, you are required to be within the state of Massachusetts at the time of your visit.",
                    "checkbox": "I will be within the state of Massachusetts at the time of my appointment."
                },
                {
                    "step": "Step 3",
                    "title": "Device",
                    "text": "You are required to use a computer or a mobile device that has a working camera, microphone, and speaker during your visit.\n\nIf you plan to attend the appointment on a mobile device, download the MyChart application in the [Apple Store]( https://apps.apple.com/us/app/mychart/id382952264) or [Google Play Store](https://play.google.com/store/apps/details?id=epic.mychart.android&hl=en_US&gl=US) before your visit.",
                    "checkbox": "I will use a computer or mobile device that has a working camera, microphone, and apeaker during my appointment."
                },
                {
                    "step": "Step 4",
                    "title": "Virtual Care Team",
                    "text": "Your virtual care visit will be with a provider from our Virtual Care Team. This appointment will **not** be with your Primary Care Provider. Your Primary Care Provider will have access to the appointment notes after your visit.",
                    "checkbox": "I understand that this appointment will be with a provider from the Virtual Care Team and **not** with my Primary Care Provider."
                }
            ]
        },
        {
            "": '',
            "allSlots": [
                {
                    "providerId": "ePbf3HEyz2120TWxKDMbc1A3",
                    "providerName": "NPS IM CLINICAL PHARMACY ()",
                    "providerPhone": "",
                    "department": "e3NoE0SCCcrs-00l6PnGuow3",
                    "date": "3/10/2022",
                    "slots": {
                        "am": [
                            "07:30",
                            "07:45",
                            "08:00",
                            "08:15",
                            "08:30",
                            "08:45",
                            "09:00",
                            "09:15"
                        ],
                        "pm": [
                            "00:00",
                            "00:15"
                        ]
                    }
                }
            ]
        }
    ]
}

export const timeOut =
{
    "type": "message",
    "text": "This conversation has timed out",
    "id": 2
}

export const age =
{
    "type": "gender",
    "text": "What is your sex?",
    "AsyncHBID": "LSnt9rW3LxT4Kk6ZIjesFK-us",
    "buttons": [
        {
            "displayText": "Male",
            "value": "Male",
            "type": "postBack"
        },
        {
            "displayText": "Female",
            "value": "Female",
            "type": "postBack"
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "current_step": "gender",
            "question_id": "UserSex",
            "version": "2.1.0-dev.101",
            "cdoName": "OptumIncubator",
            "info": {
                "type": "sex",
                "headerText": "**What should I select?**",
                "linkText": "Unsure?",
                "text": "We understand not everyone identifies as male or female. However, as a medical application, we want to offer the most appropriate symptoms and risk factors. Some are related to your sex assigned at birth."
            }
        }
    ],
    "id": 7
}

export const nps =
{
    "type": "nps",
    "text": "",
    "AsyncHBID": "408b4690-29cc-11ed-ab09-63ff88fc4ceb|livechat",
    "buttons": [],
    "hyperlinks": [],
    "attachments": { "images": [] },
    "data": [
        {
            "question_id": "NpsRatingFeedback",
            "current_step": "nps",
            "version": "1.5.3-dev.4"
        },
        {
            "npsCard": {
                "AsyncHBID": "408b4690-29cc-11ed-ab09-63ff88fc4ceb|livechat",
                "attachments": { "images": [] },
                "buttons": [],
                "data": [
                    {
                        "question_id": "NpsRating",
                        "current_step": "nps",
                        "version": "1.5.3-dev.4",
                        "headerText": "**Thank You!**",
                        "subHeaderText": "",
                        "minText": "Not Likely",
                        "maxText": "Very Likely",
                        "min": 0,
                        "max": 10,
                        "step": 1
                    }
                ],
                "hyperlinks": [],
                "language": "",
                "text": "How likely are you to recommend this symptom checker to others?",
                "type": "text"
            },
            "feedbackCard": {
                "AsyncHBID": "408b4690-29cc-11ed-ab09-63ff88fc4ceb|livechat",
                "attachments": { "images": [] },
                "buttons": [],
                "data": [
                    {
                        "question_id": "Feedback",
                        "current_step": "nps",
                        "version": "1.5.3-dev.4",
                        "headerText": "How likely are you to recommend this symptom checker to others?",
                        "subHeaderText": "This feedback will be sent to our technical team and **not** to your provider."
                    }
                ],
                "hyperlinks": [],
                "language": "",
                "text": "How likely are you to recommend this symptom checker to others?",
                "type": "text"
            },
            "thankYouCards": [
                {
                    "thankYouType": "noComment",
                    "card": {
                        "type": "text",
                        "text": "This feedback will help us uncover new ways to improve, so we can give you the best possible experience.",
                        "AsyncHBID": "408b4690-29cc-11ed-ab09-63ff88fc4ceb|livechat",
                        "language": "",
                        "buttons": [],
                        "hyperlinks": [],
                        "attachments": { "images": [] },
                        "data": [
                            {
                                "question_id": "ThankYou",
                                "headerText": "**Thank you for your response!**",
                                "subHeaderText": "",
                                "current_step": "thankyou",
                                "version": "1.5.3-dev.4"
                            }
                        ]
                    }
                },
                {
                    "thankYouType": "feedback",
                    "card": {
                        "type": "text",
                        "text": "Your feedback helps us uncover new ways to improve this symptom checker so we can continue to give you the best possible experience.",
                        "AsyncHBID": "408b4690-29cc-11ed-ab09-63ff88fc4ceb|livechat",
                        "language": "",
                        "buttons": [],
                        "hyperlinks": [],
                        "attachments": { "images": [] },
                        "data": [
                            {
                                "question_id": "ThankYou",
                                "headerText": "**Thank you for your response!**",
                                "subHeaderText": "",
                                "current_step": "thankyou",
                                "version": "1.5.3-dev.4"
                            }
                        ]
                    }
                },
                {
                    "thankYouType": "nps",
                    "card": {
                        "type": "text",
                        "text": "Your thoughts, ideas, and suggestions will help us identify any areas where we can improve.",
                        "AsyncHBID": "408b4690-29cc-11ed-ab09-63ff88fc4ceb|livechat",
                        "language": "",
                        "buttons": [],
                        "hyperlinks": [],
                        "attachments": { "images": [] },
                        "data": [
                            {
                                "question_id": "ThankYou",
                                "headerText": "**Thank you for your feedback.**",
                                "subHeaderText": "",
                                "current_step": "thankyou",
                                "version": "1.5.3-dev.4"
                            }
                        ]
                    }
                }
            ]
        }
    ]
}


export const textinput =
{
    "type": "textinput",
    "text": "**What could we do to improve?**",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": []
}

export const textcard =
{
    "type": "textcard",
    "text": "**What could we do to improve?**",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": []
}

export const treatmentplan =
{
    "type": "treatmentPlan",
    "text": "",
    "AsyncHBID": "C2yBEEPRznHDIehjsBxsWn-us",
    "language": "",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "hasSlots": true,
            "question_id": "TreatmentPlan",
            "current_step": "triage_complete_emergency",
            "virtual_visit_url": "https://semycrtpoc01/MyChartPOC/Telehealth",
            "version": "2.1.0-dev.96",
            "cdoName": "OptumIncubator"
        },
        {
            "careOptionsData": {
                "careOptions": [
                    {
                        "displayText": "I will call 9-1-1",
                        "type": "postBack",
                        "value": "NineOneOne",
                        "recommended": false
                    },
                    {
                        "displayText": "I will go to the emergency room",
                        "type": "postBack",
                        "value": "EmergencyRoom",
                        "recommended": false
                    },
                    {
                        "displayText": "I will go to ReadyMED / urgent care",
                        "type": "postBack",
                        "value": "UrgentCare",
                        "recommended": false
                    },
                    {
                        "displayText": "I will schedule an in-person appointment",
                        "type": "postBack",
                        "value": "InPerson",
                        "recommended": false
                    },
                    {
                        "displayText": "I will schedule a virtual care visit",
                        "type": "postBack",
                        "value": "VirtualCare",
                        "recommended": false
                    },
                    {
                        "displayText": "Contact me within two business days",
                        "type": "postBack",
                        "value": "ContactMe",
                        "recommended": false
                    },
                    {
                        "displayText": "I will try self-care",
                        "type": "postBack",
                        "value": "SelfCare",
                        "recommended": false
                    }
                ],
                "sectionHeader": "Please select the type of care you will seek",
                "showCareOptions": true
            }
        },
        {
            "type": "phoneNumberCard",
            "text": "Select a phone number below for our care team to reach you at:",
            "data": {
                "headerTexts": [
                    "What is your preferred contact method?",
                    "Select a phone number where our care team can reach you:",
                    "Enter your phone number below:",
                    "Can our care team leave a voice message at this phone number?"
                ],
                "contactMethods": [
                    "Message",
                    "Phone call"
                ],
                "phoneNumbers": [],
                "addNewText": "Add a new phone number",
                "yesNoButtons": [
                    "Yes",
                    "No"
                ],
                "cancelText": "Cancel",
                "backText": "Back",
                "nextText": "Next",
                "submitText": "Submit",
                "isMsgOkayText": "Yes to Voicemail",
                "isMsgNotOkayText": "No to Voicemail"
            }
        },
        {
            "EvidenceForValidation": [
                {
                    "commonName": "Severe chest pain",
                    "evidence": {
                        "id": "s_1197",
                        "choice_id": "present",
                        "source": "initial"
                    }
                },
                {
                    "commonName": "Obesity",
                    "evidence": {
                        "id": "p_7",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Smoking cigarettes",
                    "evidence": {
                        "id": "p_28",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Recent physical injury",
                    "evidence": {
                        "id": "p_264",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "High cholesterol",
                    "evidence": {
                        "id": "p_10",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                }
            ]
        },
        {
            "hpiSoapNote": {
                "hpiObject": []
            }
        },
        {
            "fhirTriageLoadData": {
                "triage_level": "emergency",
                "qna": [],
                "chief_complaints": [
                    "Severe chest pain"
                ],
                "secondary_complaints": [],
                "serious_symptoms": [
                    {
                        "id": "s_1197",
                        "name": "Chest pain, severe",
                        "common_name": "Severe chest pain",
                        "is_emergency": false
                    }
                ],
                "possible_causes": [],
                "present_risk_factors": [],
                "care_options": [
                    "{\"cdoName\":\"OptumIncubator\",\"triagelevel\":\"emergency\",\"title\":\"Emergency Care\",\"description\":\"We recommend that you **go to an Emergency Room**. Your symptoms indicate an urgent situation.\",\"link\":\"Find an Emergency Room Location\",\"href\":\"\"}"
                ],
                "denials": [],
                "gender": "Female",
                "age": 65,
                "teleconsultation_applicable": false,
                "patient_comment": ""
            }
        },
        {
            "HpiQnaAnswers": []
        }
    ],
    "id": 14
}

export const badmessage =
{
    "type": "message",
    "id": "Hvf0hQFSU7G7Ad0SJS6v1u-j|0000013",
    "timestamp": "2021-07-26T14:43:48.5976931Z",
    "channelId": "directline",
    "from": {
        "id": "asynchronous-care-nonprod-xsm0m9l",
        "name": "asynchronous-care-nonprod"
    },
    "conversation": {
        "id": "Hvf0hQFSU7G7Ad0SJS6v1u-j"
    },
    "text": "{\"type\":\"multiChoice\",\"text\":\"The following conditions appear in your medical history. You may deselect any you believe to be incorrect and click Next to continue.\",\"buttons\":[{\"displayText\":\"Next\",\"value\":\"Next\",\"type\":\"postBack\",\"ga_Identifier\":{\"category\":\"Bot Navigation\",\"action\":\"Triage-Related riskfactors Submit\"}}],\"hyperlinks\":[],\"attachments\":{\"images\":[]},\"data\":[{},[]]}",
    "speak": "{\"type\":\"multiChoice\",\"text\":\"The following conditions appear in your medical history. You may deselect any you believe to be incorrect and click Next to continue.\",\"buttons\":[{\"displayText\":\"Next\",\"value\":\"Next\",\"type\":\"postBack\",\"ga_Identifier\":{\"category\":\"Bot Navigation\",\"action\":\"Triage-Related riskfactors Submit\"}}],\"hyperlinks\":[],\"attachments\":{\"images\":[]},\"data\":[{},[]]}",
    "inputHint": "expectingInput",
    "replyToId": "Hvf0hQFSU7G7Ad0SJS6v1u-j|0000012"
}


export const error =
{
    "type": "error",
    "text": "This is a test "
}

export const groupMulti =
{
    "type": "groupMultiple",
    "text": "Which of the following worsen your chest pain?",
    "AsyncHBID": "3LA9NThFA75I9NArR1SrzA-us",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "question_id": 10,
            "explication": 'This is the explication for the group multi header text.',
            "instruction": null,
            "rationale": "I'm asking this question because a negative response reduces probability of Gastroesophageal reflux diseaseand other conditions."
        },
        [
            {
                "question": "Stress",
                "choices": [
                    {
                        "id": "present",
                        "label": "Yes"
                    },
                    {
                        "id": "absent",
                        "label": "No"
                    },
                    {
                        "id": "unknown",
                        "label": "I don't know"
                    }
                ],
                "explication": 'This is the explication for stress.',
                "instruction": null
            },
            {
                "question": "Exercising or moving",
                "choices": [
                    {
                        "id": "present",
                        "label": "Yes"
                    },
                    {
                        "id": "absent",
                        "label": "No"
                    },
                    {
                        "id": "unknown",
                        "label": "I don't know"
                    }
                ],
                "explication": null,
                "instruction": null
            },
            {
                "question": "Breathing deeply or coughing",
                "choices": [
                    {
                        "id": "present",
                        "label": "Yes"
                    },
                    {
                        "id": "absent",
                        "label": "No"
                    },
                    {
                        "id": "unknown",
                        "label": "I don't know"
                    }
                ],
                "explication": 'This is the explication for breathing deeply or coughing.',
                "instruction": null
            },
            {
                "question": "Bending or twisting the upper body",
                "choices": [
                    {
                        "id": "present",
                        "label": "Yes"
                    },
                    {
                        "id": "absent",
                        "label": "No"
                    },
                    {
                        "id": "unknown",
                        "label": "I don't know"
                    }
                ],
                "explication": null,
                "instruction": null
            },
            {
                "question": "Pressing on the chest",
                "choices": [
                    {
                        "id": "present",
                        "label": "Yes"
                    },
                    {
                        "id": "absent",
                        "label": "No"
                    },
                    {
                        "id": "unknown",
                        "label": "I don't know"
                    }
                ],
                "explication": null,
                "instruction": null
            },
            {
                "question": "Lying down",
                "choices": [
                    {
                        "id": "present",
                        "label": "Yes"
                    },
                    {
                        "id": "absent",
                        "label": "No"
                    },
                    {
                        "id": "unknown",
                        "label": "I don't know"
                    }
                ],
                "explication": null,
                "instruction": null
            }
        ],
        {
            "question": {
                "type": "group_multiple",
                "text": "Which of the following worsen your chest pain?",
                "explication": null,
                "instruction": null,
                "items": [
                    {
                        "id": "s_1763",
                        "name": "Stress",
                        "explication": 'Explication for the first question.',
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "I don't know"
                            }
                        ]
                    },
                    {
                        "id": "s_35",
                        "name": "Exercising or moving",
                        "explication": null,
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "I don't know"
                            }
                        ]
                    },
                    {
                        "id": "s_30",
                        "name": "Breathing deeply or coughing",
                        "explication": 'Explication for the third question. With a soda on the side.',
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "I don't know"
                            }
                        ]
                    },
                    {
                        "id": "s_2051",
                        "name": "Bending or twisting the upper body",
                        "explication": null,
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "I don't know"
                            }
                        ]
                    },
                    {
                        "id": "s_1178",
                        "name": "Pressing on the chest",
                        "explication": null,
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "I don't know"
                            }
                        ]
                    },
                    {
                        "id": "s_2006",
                        "name": "Lying down",
                        "explication": null,
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "I don't know"
                            }
                        ]
                    }
                ],
                "extras": {}
            },
            "conditions": [
                {
                    "id": "c_976",
                    "name": "Chest pain, unspecified",
                    "common_name": "Unspecific chest pain",
                    "probability": 0.092
                },
                {
                    "id": "c_101",
                    "name": "Gastroesophageal reflux disease",
                    "common_name": "Gastroesophageal reflux disease",
                    "probability": 0.036
                }
            ],
            "extras": {},
            "has_emergency_evidence": false,
            "should_stop": false
        }
    ],
    "id": 24
}


export const provider =
{
    'id': 8234,
    "type": "provider",
    "text": "**Select a provider.** They will receive a copy of the transcript along with your results from the symptom checker.",
    "buttons": [],
    "hyperlinks": [],
    "attachments": { "images": [] },
    "data":
        [
            {
                "pcpText": 'Your Primary Care Provider',
                "header": 'Share this information with your provider.',
                "subHeaderText": 'Select the name of a provider below to share. Any provider within your health system also has teh ability to view this transcript. If you need to schedule an appointment, call the phone number listed.',
                "current_step": "provider"
            },
            [
                { "id": "97", "name": "Lawrence Garber ", "speciality": "Internal Medicine", "type": "PCP", "phone": "1255-689-1234" },
                { "id": "102", "name": "Steve Smith ", "speciality": "External Medicine", "type": "Other", "phone": "269-2283" }
            ]
        ]
}

export const nine11 =
{
    "type": "nine11",
    "data": [{ headerText: '**Please call 9-1-1 immediately**' }],
    "text": "  \nYour symptoms indicate an emergency situation.",
    "id": 1
}

export const emergency =
{
    "type": "emergency",
    "data": [{ headerText: '**Please go to your closest Emergency Room or Urgent Care.**' }],
    "text": "  \nYour symptoms indicate an urgent situation.",
    "id": 1
}

export const oops =
{
    "type": "oops",
    "text": "**Oops**  \nSomething went wrong on our end. We apologize for the inconvenience, please click \"restart\" to start again.",
    "id": 1
}

export const symptomCard =
{
    "attachments": {
        "images": []
    },
    "AsyncHBID": "3yp6qPRbS8iIihWJTfszPE-us",
    "buttons": [],
    "hyperlinks": [],
    "text": "Add your current symptoms. Choosing more than one symptom helps with your results. If you are hurt and in pain, include it in your symptoms.",
    "type": "symptomsCard",
    "data": [
        {
            "addMore": "Please consider adding more than one symptom.",
            "cdoName": "OptumIncubator",
            "current_step": "symptoms",
            "headerText": "**Add your Symptoms**",
            "newSearch": "Start a new search",
            "noResults": "**No results**<br><br>Unfortunately, the symptom was not found.<br><br>* Please try to enter single words<br>* Keep in mind, that you can only select symptoms form the autocomplete list",
            "onlySix": "We can accept up to 6 symptoms. Please only add your current symptoms.",
            "placeHolder": "Search for a symptom or injury",
            "question_id": "Symptoms",
            "rotateText": "Rotate figure",
            "trySearch": "Can't find your symptom? Please try to use the search box.",
            "userAge": 65,
            "userSex": "female",
            "version": "2.1.0-dev.99"
        },
        {
            "EvidenceForValidation": []
        }
    ],
    "id": 7
}

export const symptomsDurationCard =
{
    "type": "symptomsDurationCard",
    "text": "",
    "AsyncHBID": "0b662960-7d7e-11ee-834b-c1effa7ead54",
    "hostName": "InstanceIdNotSet",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "current_step": "scheduleappointment",
            "question_id": "SymptomsDuration",
            "version": "2.8.0.29",
            "cdoName": "OptumIncubator",
            "headerText": "**Select Duration**",
            "subHeaderText": "Enter how long you have had each symptom."
        },
       {
            durationUnits: [{displayText:"Week[s]",value:"week"},{displayText:"Day[s]",value:"day"},{displayText:"Hour[s]",value:"hour"},{displayText:"Minute[s]",value:"minute"}],
            tableHeaders: [
                "**Symptoms**",
                "**Duration**",
                "**Type**"
            ],
            symptoms: [{name:"Headache",id:"s_21"},{name:"Fever",id:"s_98"},{name:"Cough",id:"s_102"},{name:"Heartburn",id:"s_338"},{name:"Toothache",id:"s_551"}],
        },
        {}
    ]
}

export const symptomsQuestionCard =
{
    "type": "symptomsQuestionCard",
    "text": "",
    "AsyncHBID": "0b662960-7d7e-11ee-834b-c1effa7ead54",
    "hostName": "InstanceIdNotSet",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "current_step": "symptoms_duration",
            "question_id": "SymptomsQuestion",
            "version": "2.8.0.29",
            "cdoName": "OptumIncubator",
            "headerText": "**Select Question Duration**",
            "subHeaderText": "Since How long you are suffering from Heartpain?",
            
        },
       {
           durationUnits: [{ displayText: "Week[s]", value: "week" }, { displayText: "Day[s]", value: "day" }, { displayText: "Hour[s]", value: "hour" }, { displayText: "Minute[s]", value: "minute" }],
           symptomId:"s_13"
        },
        {}
    ]
}

export const multiChoice = {
    "type": "multiChoice",
    "text": "Do you have any of the following pre-existing conditions?",
    "buttons": [
        {
            "displayText": "Submit",
            "value": "Submit",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Triage-Related riskfactors Submit"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "current_step": "red_flag",
            "question_id": 4
        },
        [
            {
                "displayText": "Pregnancy",
                "value": "Pregnancy",
                "selected": true
            },
            {
                "displayText": "Recent physical injury",
                "value": "Recent physical injury",
                "selected": true
            },
            {
                "displayText": "Diabetes",
                "value": "Diabetes",
                "selected": true
            },
            {
                "displayText": "Hypertension",
                "value": "Hypertension",
                "selected": true
            },
            {
                "displayText": "High cholesterol",
                "value": "High cholesterol",
                "selected": true
            },
            {
                "displayText": "None of the above",
                "value": "none",
                "selected": false
            }
        ],
        [
            {
                "index": 0,
                "answer": "Next",
                "evidence": []
            },
            {
                "index": 1,
                "answer": "No",
                "evidence": []
            },
            {
                "index": 2,
                "answer": "headache,",
                "evidence": [
                    {
                        "id": "s_21",
                        "choice_id": "present",
                        "source": "initial"
                    }
                ],
                "triage_output": {
                    "qna": [],
                    "chief_complaints": [
                        "Headache"
                    ],
                    "secondary_complaints": [],
                    "serious_symptoms": [],
                    "possible_causes": [],
                    "present_risk_factors": [],
                    "care_options": [],
                    "denials": []
                }
            }
        ],
        {
            "mentions": [
                {
                    "id": "s_21",
                    "name": "Headache",
                    "common_name": "Headache",
                    "orth": "headache",
                    "choice_id": "present",
                    "type": "symptom"
                }
            ],
            "obvious": true
        }
    ],
    "botName": "Laura",
    "timestamp": "2021-06-25T18:38:37.0724353Z",
    "id": 11
}

export const prompt =
{
    "type": "prompt",
    "text": "What is your COVID-19 vaccination status?",
    "AsyncHBID": "GcwHNgG9V9a4WGgJ1rpybE-us",
    "buttons": [
        {
            "displayText": "Fully vaccinated, the last dose received at least two weeks ago.",
            "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
            "value": "0",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Interview question Selection: Fully vaccinated, the last dose received at least two weeks ago."
            }
        },
        {
            "displayText": "Vaccinated, but not fully",
            "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
            "value": "1",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Interview question Selection: Vaccinated, but not fully"
            }
        },
        {
            "displayText": "Not vaccinated",
            "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
            "value": "2",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Interview question Selection: Not vaccinated"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "question_id": 8,
            "explication": 'This is a test explication. This is only a test.',
            "instruction": null,
            "rationale": "I'm asking this question to learn more about your Cough."
        },
        {
            "question": {
                "type": "group_single",
                "text": "What is your COVID-19 vaccination status?",
                "explication": null,
                "instruction": null,
                "items": [
                    {
                        "id": "p_332",
                        "name": "Fully vaccinated, the last dose received at least two weeks ago.",
                        "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "Don't know"
                            }
                        ]
                    },
                    {
                        "id": "p_331",
                        "name": "Vaccinated, but not fully",
                        "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "Don't know"
                            }
                        ]
                    },
                    {
                        "id": "p_330",
                        "name": "Not vaccinated",
                        "explication": "One is considered to be fully vaccined 2 weeks after their second dose in a 2-dose series, or\n2 weeks after a single-dose vaccine",
                        "instruction": null,
                        "choices": [
                            {
                                "id": "present",
                                "label": "Yes"
                            },
                            {
                                "id": "absent",
                                "label": "No"
                            },
                            {
                                "id": "unknown",
                                "label": "Don't know"
                            }
                        ]
                    }
                ],
                "extras": {}
            },
            "conditions": [
                {
                    "id": "c_971",
                    "name": "Cough, unspecified",
                    "common_name": "Unspecific cough",
                    "probability": 0.1231
                }
            ],
            "extras": {},
            "has_emergency_evidence": false,
            "should_stop": false
        }
    ],
    "id": 20
}

export const welcome =
{
    "type": "welcome", "id": 156, "text": "You will be asked a series of questions regarding your current symptoms. Your answers will be analyzed to provide you with a list of possible causes and next steps to treat your symptoms.\n\nA report with your results will be shared with [-] [Share this report with a different provider.](-)", "AsyncHBID": "70377c40-ab84-11ec-bed1-513555f41f9e|livechat", "buttons": [{ "displayText": "Next", "value": "Next", "type": "postBack" }], "hyperlinks": [], "attachments": { "images": [] },
    "data": [{ "headerText": "Welcome to your virtual health assistant,", "current_step": "welcome", "question_id": "Welcome", "age": 65, "gender": "Female", "checkBoxText": "I understand that my responses from this symptom checker will become part of my **medical record** and be shared with [-].", "subHeaderText": "Select the name of a provider below to share. Any provider within your health system also has the ability to view this transcript. If you need to schedule an appointment, call the phone number listed." }, {
        "type": "providers", "pcpText": "Your primary care provider", "headerText": "Which provider would you like to share this report with?",
        "data": [
            { "id": "eOLurbYbPBykce9ALEa7XYg3", "providerName": "Wendy Bergman (Internal Medicine)^774-778-5234^pcp", "providerSpecialty": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocation": ["Neponset Internal Medicine", "Auburn ReadyMed", "Milford ReadyMed", "Hudson ReadyMed", "READYMED PLUS SHREWSBURY ST", "Readymed Plus Shrewsbury St Infusion Ctr", "Neponset Respiratory Clinic"], "providerLocationAddress": ["5 NEPONSET ST", "460 SOUTHBRIDGE ST", "340 EAST MAIN ST", "234 Washington Street", "366 SHREWSBURY ST", "366 SHREWSBURY ST", "5 NEPONSET ST"], "providerLocationCity": ["WORCESTER", "AUBURN", "MILFORD", "HUDSON", "WORCESTER", "WORCESTER", "WORCESTER"], "providerSpecialtyID": ["17", "100", "100", "100", "100", "100", "9"], "providerSpeciality": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocationID": ["e3NoE0SCCcrs-00l6PnGuow3", "eB5298U9qEeMRP3dbPHxiIw3", "eV1ijWVLu6wTVhyr6I69rPQ3", "eZ7D1BjjO-yLuCPceHCNc5w3", "eJ6crSYmIOvJFccF0WXP4OQ3", "eVI6PuBeqBEOiEqlPxf7WDA3", "e.o0xsav.F-gf5P57ss73fw3"], "providerCapabilitiesID": ["0", "0", "0"], "careType": "Async Care Team", "name": "Wendy Bergman", "speciality": "Internal Medicine", "type": "Async Care Team", "phone": "774-778-5234" },
            { "id": "eOLurbYbPBykce9ALda7XYg3", "providerName": "Sandy Bergman (Internal Medicine)^774-778-5233", "providerSpecialty": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocation": ["Neponset Internal Medicine", "Auburn ReadyMed", "Milford ReadyMed", "Hudson ReadyMed", "READYMED PLUS SHREWSBURY ST", "Readymed Plus Shrewsbury St Infusion Ctr", "Neponset Respiratory Clinic"], "providerLocationAddress": ["5 NEPONSET ST", "460 SOUTHBRIDGE ST", "340 EAST MAIN ST", "234 Washington Street", "366 SHREWSBURY ST", "366 SHREWSBURY ST", "5 NEPONSET ST"], "providerLocationCity": ["WORCESTER", "AUBURN", "MILFORD", "HUDSON", "WORCESTER", "WORCESTER", "WORCESTER"], "providerSpecialtyID": ["17", "100", "100", "100", "100", "100", "9"], "providerSpeciality": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocationID": ["e3NoE0SCCcrs-00l6PnGuow3", "eB5298U9qEeMRP3dbPHxiIw3", "eV1ijWVLu6wTVhyr6I69rPQ3", "eZ7D1BjjO-yLuCPceHCNc5w3", "eJ6crSYmIOvJFccF0WXP4OQ3", "eVI6PuBeqBEOiEqlPxf7WDA3", "e.o0xsav.F-gf5P57ss73fw3"], "providerCapabilitiesID": ["0", "0", "0"], "careType": "Async Care Team", "name": "Sandy Bergman", "speciality": "Internal Medicine", "type": "Async Care Team", "phone": "774-778-5234" },
            { "id": "eOLurbYbPBykcesALEa7XYg3", "providerName": "Bill Bergman (Internal Medicine)^774-778-5234", "providerSpecialty": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocation": ["Neponset Internal Medicine", "Auburn ReadyMed", "Milford ReadyMed", "Hudson ReadyMed", "READYMED PLUS SHREWSBURY ST", "Readymed Plus Shrewsbury St Infusion Ctr", "Neponset Respiratory Clinic"], "providerLocationAddress": ["5 NEPONSET ST", "460 SOUTHBRIDGE ST", "340 EAST MAIN ST", "234 Washington Street", "366 SHREWSBURY ST", "366 SHREWSBURY ST", "5 NEPONSET ST"], "providerLocationCity": ["WORCESTER", "AUBURN", "MILFORD", "HUDSON", "WORCESTER", "WORCESTER", "WORCESTER"], "providerSpecialtyID": ["17", "100", "100", "100", "100", "100", "9"], "providerSpeciality": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocationID": ["e3NoE0SCCcrs-00l6PnGuow3", "eB5298U9qEeMRP3dbPHxiIw3", "eV1ijWVLu6wTVhyr6I69rPQ3", "eZ7D1BjjO-yLuCPceHCNc5w3", "eJ6crSYmIOvJFccF0WXP4OQ3", "eVI6PuBeqBEOiEqlPxf7WDA3", "e.o0xsav.F-gf5P57ss73fw3"], "providerCapabilitiesID": ["0", "0", "0"], "careType": "Async Care Team", "name": "joe Bergman", "speciality": "Internal Medicine", "type": "Async Care Team", "phone": "774-778-5234" },
            { "id": "eOLurbYbPBysce9ALEa7XYg3", "providerName": "Paul Bergman (Internal Medicine)^774-778-5233", "providerSpecialty": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocation": ["Neponset Internal Medicine", "Auburn ReadyMed", "Milford ReadyMed", "Hudson ReadyMed", "READYMED PLUS SHREWSBURY ST", "Readymed Plus Shrewsbury St Infusion Ctr", "Neponset Respiratory Clinic"], "providerLocationAddress": ["5 NEPONSET ST", "460 SOUTHBRIDGE ST", "340 EAST MAIN ST", "234 Washington Street", "366 SHREWSBURY ST", "366 SHREWSBURY ST", "5 NEPONSET ST"], "providerLocationCity": ["WORCESTER", "AUBURN", "MILFORD", "HUDSON", "WORCESTER", "WORCESTER", "WORCESTER"], "providerSpecialtyID": ["17", "100", "100", "100", "100", "100", "9"], "providerSpeciality": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocationID": ["e3NoE0SCCcrs-00l6PnGuow3", "eB5298U9qEeMRP3dbPHxiIw3", "eV1ijWVLu6wTVhyr6I69rPQ3", "eZ7D1BjjO-yLuCPceHCNc5w3", "eJ6crSYmIOvJFccF0WXP4OQ3", "eVI6PuBeqBEOiEqlPxf7WDA3", "e.o0xsav.F-gf5P57ss73fw3"], "providerCapabilitiesID": ["0", "0", "0"], "careType": "Async Care Team", "name": "William Bergman", "speciality": "Internal Medicine", "type": "Async Care Team", "phone": "774-778-5234" },
            { "id": "eOLurbYbaBykce9ALEa7XYg3", "providerName": "Joe Bergman (Internal Medicine)^774-778-5234", "providerSpecialty": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocation": ["Neponset Internal Medicine", "Auburn ReadyMed", "Milford ReadyMed", "Hudson ReadyMed", "READYMED PLUS SHREWSBURY ST", "Readymed Plus Shrewsbury St Infusion Ctr", "Neponset Respiratory Clinic"], "providerLocationAddress": ["5 NEPONSET ST", "460 SOUTHBRIDGE ST", "340 EAST MAIN ST", "234 Washington Street", "366 SHREWSBURY ST", "366 SHREWSBURY ST", "5 NEPONSET ST"], "providerLocationCity": ["WORCESTER", "AUBURN", "MILFORD", "HUDSON", "WORCESTER", "WORCESTER", "WORCESTER"], "providerSpecialtyID": ["17", "100", "100", "100", "100", "100", "9"], "providerSpeciality": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocationID": ["e3NoE0SCCcrs-00l6PnGuow3", "eB5298U9qEeMRP3dbPHxiIw3", "eV1ijWVLu6wTVhyr6I69rPQ3", "eZ7D1BjjO-yLuCPceHCNc5w3", "eJ6crSYmIOvJFccF0WXP4OQ3", "eVI6PuBeqBEOiEqlPxf7WDA3", "e.o0xsav.F-gf5P57ss73fw3"], "providerCapabilitiesID": ["0", "0", "0"], "careType": "Async Care Team", "name": "Phillip Bergman", "speciality": "Internal Medicine", "type": "Async Care Team", "phone": "774-778-5234" },
            { "id": "eOLurbYbPBykge9ALEa7XYg3", "providerName": "Johnathon Bergman (Internal Medicine)^774-778-5233", "providerSpecialty": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocation": ["Neponset Internal Medicine", "Auburn ReadyMed", "Milford ReadyMed", "Hudson ReadyMed", "READYMED PLUS SHREWSBURY ST", "Readymed Plus Shrewsbury St Infusion Ctr", "Neponset Respiratory Clinic"], "providerLocationAddress": ["5 NEPONSET ST", "460 SOUTHBRIDGE ST", "340 EAST MAIN ST", "234 Washington Street", "366 SHREWSBURY ST", "366 SHREWSBURY ST", "5 NEPONSET ST"], "providerLocationCity": ["WORCESTER", "AUBURN", "MILFORD", "HUDSON", "WORCESTER", "WORCESTER", "WORCESTER"], "providerSpecialtyID": ["17", "100", "100", "100", "100", "100", "9"], "providerSpeciality": ["Internal Medicine", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Urgent Care", "Family Practice"], "providerLocationID": ["e3NoE0SCCcrs-00l6PnGuow3", "eB5298U9qEeMRP3dbPHxiIw3", "eV1ijWVLu6wTVhyr6I69rPQ3", "eZ7D1BjjO-yLuCPceHCNc5w3", "eJ6crSYmIOvJFccF0WXP4OQ3", "eVI6PuBeqBEOiEqlPxf7WDA3", "e.o0xsav.F-gf5P57ss73fw3"], "providerCapabilitiesID": ["0", "0", "0"], "careType": "Async Care Team", "name": "Bradley Bergman", "speciality": "Internal Medicine", "type": "Async Care Team", "phone": "774-778-5234" }
        ]
    }]    
}

export const welcomenew={
    "type": "welcomeNew",
    "text": "You will be asked a series of questions regarding your current symptoms. Your answers will be analyzed to provide you with a list of possible causes and next steps to treat your symptoms.",
    "AsyncHBID": "HU3p9AqaADrJdduXsX2CAZ-us",
    "hostName": "046ccb6232de3cf1864415e4b65e42efc5adde8c935253c0b8b3f9e29e928c4a",
    "buttons": [
        {
            "displayText": "Next",
            "value": "Next",
            "type": "postBack"
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "current_step": "welcome",
            "question_id": "Welcome",
            "age": 45,
            "gender": "Female",
            "version": "3.6.0",
            "cdoName": "NWest",
            "welcomeText": "Welcome to Symptom Smart",
            "symptomText": "Identify potential conditions and treatments based on your symptoms.",
            "approvalText": "Fast, free, and easy. Doctor approved.",
            "emergencyText": "Call 911 if you are experiencing a medical emergency.",
            "buttonText": "Agree and continue to Symptom Smart",
            "disclaimerText": "This tool does not provide medical advice.It is intended for informational purposes only.",
            "hipaaText": "HIPAA compliant",
            "copyrightText": "©2025 Optum. All rights reserved.",
            "cancelButtonText": "Cancel and return to MyChart",
            "termsText": "By continuing, you are agreeing to our [Terms of Use](https://www.oregonmedicalgroup.com/terms-conditions) and [Privacy Policy](https://www.oregonmedicalgroup.com/s/Oregon-Medical-Group-OMG_NPP.pdf).",
            "myChartLink": "https://epicpnwmychartnp.optum.com/MyChartWPOC/Home",
            "superScriptText": "TM"
        },
        {
            "type": "providers",
            "pcpText": "",
            "headerText": null,
            "data": [
                {
                    "id": "e984aN2wikZXKSqILSjjyLg3",
                    "name": "William Brus",
                    "specialty": [
                        "Family Medicine",
                        "Family Medicine"
                    ],
                    "location": [
                        "Primary Care at Mohawk Medical Clinic",
                        "Primary Care at Crescent Medical Clinic"
                    ],
                    "locationAddress": [
                        "2000 North 19th St",
                        "2830 Crescent Ave"
                    ],
                    "locationCity": [
                        "Springfield",
                        "Eugene"
                    ],
                    "specialtyID": [
                        "9",
                        "9"
                    ],
                    "locationID": [
                        "egNx4ODd8cfJZXZiZi7uqbtQUmRoddnD0xMzd-cjz0ns3",
                        "evBMjK.GLa8JJKFuDgUcIaOMWk.qNPwlUExw.PXP.zH43"
                    ],
                    "capabilitiesID": [
                        "0",
                        "2200",
                        "2200",
                        "84",
                        "4001008001",
                        "2200",
                        "84",
                        "4001008001",
                        "2",
                        "2",
                        "41",
                        "3"
                    ],
                    "specialities": [
                        "Family Medicine",
                        "Family Medicine"
                    ],
                    "providerName": "William Brus (Family Medicine)^541-746-5437^PCP",
                    "speciality": "Family Medicine",
                    "type": "Async Care Team",
                    "phone": "541-746-5437",
                    "pcp": true,
                    "genericPcp": false,
                    "nonEstablished": false
                }
            ]
        }
    ],
    "id": 1
}

export const rangecard = {
    type: "range",
    text: "How likely are you to recommend the **I'm Sick** button to others?",
    buttons: [],
    hyperlinks: [],
    attachments: {
        images: []
    },
    data: [
        {
            minText: "Not Likely",
            maxText: "Very Likely",
            min: 0,
            max: 10,
            step: 1,
            title: "**Thank you!**",
            text: "Thank you for your response. We really appreaciate your feedback!"
        }
    ]
}

export const ApptConfirmCard = { "type": "apptConfirm", "text": "", "buttons": [], "hyperlinks": [], "attachments": { "images": [] }, "data": [{ "appointment_time": "3:00 PM", "appointment_date": "2020/11/23" }, { "doctor_data": { "Providersinfo": [{ "Practitioner_ID": "11", "suffix": "", "FullName": "Manning, Terry", "FirstName": "Terry", "MiddleInitial": "", "LastName": "Manning", "Gender": "M", "Abbreviation": "Manning", "Address": { "Street1": "101 Allscritps way", "Street2": "", "State": "NC", "City": "Raleig", "Countrycode": "", "zipcode": "27816", "Phone": "9198889911" } }] } }] }

export const Input = {
    "type": "TextInput",
    "text": "Thanks. You're all set! I'll send you a text message reminder of your appointment date and time at the number below. Please confirm that I have the correct mobile number.",
    "buttons": [
        {
            "displayText": "Confirm",
            "value": "Confirm",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Confirm Phone Number"
            }
        },
        {
            "displayText": "Change number",
            "value": "Change number",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Change phone number"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "phone": "16035577777"
        }
    ],
    "timestamp": "2021-01-15T17:44:12.5291897Z",
    "id": "0000012"
}

export const phoneCard = {
    "type": "phoneCard",
    "text": "Thanks. You're all set! I'll send you a text message reminder of your appointment date and time at the number below. Please confirm that I have the correct mobile number.",
    "buttons": [
        {
            "displayText": "Confirm",
            "value": "Confirm",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Confirm Phone Number"
            }
        },
        {
            "displayText": "Change number",
            "value": "Change number",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Change phone number"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "data": [
        {
            "phone": "16035577777"
        }
    ],
    "timestamp": "2021-01-15T17:44:12.5291897Z",
    "id": "0000012"
}

export const timeCard = {
    type: "timeCard",
    text: "Please select an appointment Time that works best for you.",
    buttons: [],
    hyperlinks: [],
    attachments: {
        images: []
    },
    data: [
        "{\"Schedulinfo\":[{\"availabledate\":\"11/18/2020\",\"slots\":[\"9:00 AM\",\"9:15 AM\",\"9:30 AM\",\"9:45 AM\",\"10:00 AM\",\"10:15 AM\",\"10:30 AM\",\"10:45 AM\",\"11:00 AM\",\"11:15 AM\",\"11:30 AM\",\"11:45 AM\",\"1:00 PM\",\"1:15 PM\",\"1:30 PM\",\"1:45 PM\",\"2:00 PM\",\"2:15 PM\",\"2:30 PM\",\"2:45 PM\",\"3:00 PM\",\"3:15 PM\",\"3:30 PM\",\"3:45 PM\",\"4:00 PM\",\"4:15 PM\",\"4:30 PM\",\"4:45 PM\",\"5:00 PM\",\"5:15 PM\",\"5:30 PM\",\"5:45 PM\"]}]}",
        " {\"Providersinfo\":[{\"Practitioner_ID\":\"11\",\"suffix\":\"\",\"FullName\":\"Manning, Terry\",\"FirstName\":\"Terry\",\"MiddleInitial\":\"\",\"LastName\":\"Manning\",\"Gender\":\"M\",\"Abbreviation\":\"Manning\",\"Address\":{\"Street1\":\"101 Allscritps way\",\"Street2\":\"\",\"State\":\"NC\",\"City\":\"Raleig\",\"Countrycode\":\"\",\"zipcode\":\"27816\",\"Phone\":\"9198889911\"}}]} "
    ]
}


export const confirm =
{
    "type": "confirmation",
    "language": "en_us",
    "text": "",
    "AsyncHBID": "2c991f20-9fcc-11ec-9e0a-1ba64661d563|livechat",
    "buttons": [],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "id": 2,
    "data": [
        {
            "question_id": "CONFIRMATION",
            "headerText": "Your appointment is confirmed for **Monday, March 3rd, 2022** at **10:15 AM** with a provider from our virtual care team.",
            "subHeaderText": "**You will be needed to complete pre-check in questionnaire, found on MyChart home page, prior to your appointment.** <br><br>Visit our website for more information and details on [how to prepare for your virtual visit](). If you need to reschedule, or have questions directly related to your appointment, contact the virtual care team at 508-595-2300."
        }
    ]
}

export const calendar =
{
    "type": "calendar",
    "text": "Select a date and time for your virtual care visit",
    "AsyncHBID": "90M4IiwyYha4o5w4eDESXV-us",
    "buttons": [
        {
            "displayText": "Confirm",
            "value": "Confirm",
            "type": "postBack"
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "id": 4,
    "data": [
        {
            "question_id": "SCHEDULING",
            "headerText": "Select a date and time for your virtual care visit",
            "subHeaderText": "We can only provide you with the next two days of available appointments.",
            "errorInScheduling": false,
            "errorMessage": "",
            "selectedDate": ""
        },
        {
            "allSlots": [
                {
                    "providerId": "eAfrEt.sSwvcrX0JpdMJR2g3",
                    "providerName": "NPS IM CLINICAL PHARMACY ()",
                    "providerPhone": "",
                    "department": "e3NoE0SCCcrs-00l6PnGuow3",
                    "slots": [
                        1651075200000,
                        1651076100000,
                        1651077000000,
                        1651077900000,
                        1651078800000,
                        1651079700000,
                        1651080600000,
                        1651081500000,
                        1651131000000,
                        1651131900000,
                        1651132800000,
                        1651133700000,
                        1651134600000,
                        1651135500000,
                        1651136400000,
                        1651137300000,
                        1651138200000,
                        1651139100000,
                        1651140000000,
                        1651140900000,
                        1651141800000,
                        1651142700000,
                        1651143600000,
                        1651144500000,
                        1651145400000,
                        1651146300000,
                        1651147200000,
                        1651148100000,
                        1651149000000,
                        1651149900000,
                        1651150800000,
                        1651151700000,
                        1651152600000,
                        1651153500000,
                        1651154400000,
                        1651155300000,
                        1651156200000,
                        1651157100000,
                        1651158000000,
                        1651158900000,
                        1651159800000,
                        1651160700000,
                        1651161600000,
                        1651162500000,
                        1651163400000,
                        1651164300000,
                        1651165200000,
                        1651166100000,
                        1651167000000,
                        1651167900000,
                        1651192200000
                    ]
                }
            ]
        }
    ]
}

export const apterror =
{
    "type": "calendar",
    "language": "en_us",
    "text": "Select a date and time for your virtual care visit",
    "AsyncHBID": "567cff80-9ee3-11ec-b0bc-23a4d8f5c460|livechat",
    "buttons": [
        {
            "displayText": "Confirm",
            "value": "Confirm",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Schedule an Appointment - Schedule My Virtual Care Visit"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    },
    "id": 112345,
    "data": [
        {
            "question_id": "SCHEDULING",
            "headerText": "Select a date and time for your virtual care visit",
            "subHeaderText": "We can provide you with the only two days worth of available appointments."
        },
        {
            "errorInScheduling": true,
            "errorMessage": "Squickem",
            "selectedDate": "",
            "allSlots": {
                "schedules": [
                    {
                        "providerId": "ePbf3HEyz2120TWxKDMbc1A3",
                        "providerName": "NPS IM CLINICAL PHARMACY ()",
                        "providerPhone": "",
                        "department": "e3NoE0SCCcrs-00l6PnGuow3",
                        "date": "3/8/2022",
                        "slots": {
                            "am": [
                                "08:30",
                                "08:45",
                                "09:00",
                                "09:15",
                                "09:30",
                                "11:45"
                            ],
                            "pm": [
                                "00:00",
                                "00:15",
                                "00:30",
                                "00:45",
                                "01:00",
                                "01:15",
                                "01:30",
                                "01:45",
                                "02:00"
                            ]
                        }
                    },
                    {
                        "providerId": "ePbf3HEyz2120TWxKDMbc1A3",
                        "providerName": "NPS IM CLINICAL PHARMACY ()",
                        "providerPhone": "",
                        "department": "e3NoE0SCCcrs-00l6PnGuow3",
                        "date": "3/9/2022",
                        "slots": {
                            "am": [
                                "10:30",
                                "10:45",
                                "11:00",
                                "11:15",
                                "11:30",
                                "11:45"
                            ],
                            "pm": [
                                "00:00",
                                "00:15",
                                "00:30",
                                "00:45",
                                "01:00"
                            ]
                        }
                    },
                    {
                        "providerId": "ePbf3HEyz2120TWxKDMbc1A3",
                        "providerName": "NPS IM CLINICAL PHARMACY ()",
                        "providerPhone": "",
                        "department": "e3NoE0SCCcrs-00l6PnGuow3",
                        "date": "3/10/2022",
                        "slots": {
                            "am": [
                                "07:30",
                                "07:45",
                                "08:00",
                                "08:15",
                                "08:30",
                                "08:45",
                                "09:00",
                                "09:15"
                            ],
                            "pm": [
                                "00:00",
                                "00:15"
                            ]
                        }
                    }
                ]
            }
        }
    ]
}

export const warning = {
    "type": "warning",
    "text": "**Oops, something went wrong on our end. We apologize for the inconvenience, please click \"restart\".**",
    "buttons": [
        {
            "displayText": "Restart",
            "value": "Restart",
            "type": "postBack",
            "ga_Identifier": {
                "category": "Bot Navigation",
                "action": "Error - Restart"
            }
        }
    ],
    "hyperlinks": [],
    "attachments": {
        "images": []
    }
}

export const summaryMessage =
{
    "type": "summary",
    "text": "",
    "AsyncHBID": "1rB9v7DReQkJykCFlohuJO-us",
    "buttons": [],
    "hyperlinks": [],
    "hostName": "b490231cd50ba963c5d1c203c505a1b0e0d7a6b1dfa1e876a0648fb2ab9a862c",
    "attachments": {
        "images": []
    },
    "data": [
        {
            "FormatCode": "OptumIncubator",
            "cdoName": "OptumIncubator",
            "channel": "personal_visit",
            "final_triage": "urgent_care",
            "hasSlots": true,
            "inPersonText": "",
            "question_id": "Summary",
            "current_step": "triage_complete",
            "triage": "consultation_24",
            "triageMapping": {
                "cdoName": "OptumIncubator",
                "description": "We recommend that you **go to Urgent Care** for a walk-in appointment.",
                "href": null,
                "link": "Find an Urgent Care Location",
                "title": "Urgent Care",
                "triagelevel": "urgent_care"
            },
            "version": "2.6.0-dev.51",
            "virtual_visit_url": "https://semycrtpoc01/MyChartPOC/Telehealth"
        },
        {
            "triage_level": "urgent_care",
            "qna": [
                {
                    "question": "What is your body temperature?",
                    "answer": "It wasn't measured",
                    "id": [
                        "s_1820"
                    ],
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "question": "How would you describe the cough?",
                    "answer": "Wet cough, with phlegm or mucus",
                    "id": [
                        "s_104"
                    ],
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "question": "How would you describe the wet cough?",
                    "answer": "The mucus is thick and yellow or green",
                    "id": [
                        "s_526"
                    ],
                    "type": "group_multiple",
                    "evidence": "present"
                },
                {
                    "question": "How would you describe the wet cough?",
                    "answer": "The mucus is pink and frothy",
                    "id": [
                        "s_670"
                    ],
                    "type": "group_multiple",
                    "evidence": "absent"
                },
                {
                    "question": "How would you describe the wet cough?",
                    "answer": "Often comes in the morning",
                    "id": [
                        "s_662"
                    ],
                    "type": "group_multiple",
                    "evidence": "present"
                },
                {
                    "question": "How long have you had a fever?",
                    "answer": "Less than 3 days",
                    "id": [
                        "s_2319"
                    ],
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "question": "How strong is the headache?",
                    "answer": "Moderate",
                    "id": [
                        "s_1781"
                    ],
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "question": "How long have you had a cough?",
                    "answer": "Less than 3 weeks",
                    "id": [
                        "s_103"
                    ],
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "question": "Do you have a sore throat?",
                    "answer": "No",
                    "id": [
                        "s_20"
                    ],
                    "type": "single",
                    "evidence": "absent"
                },
                {
                    "question": "Do you have a cough during the night that sometimes wakes you up?",
                    "answer": "No",
                    "id": [
                        "s_1985"
                    ],
                    "type": "single",
                    "evidence": "absent"
                },
                {
                    "question": "Do you have intermittent attacks of uncontrollable, violent coughing, making it hard to breathe?",
                    "answer": "Yes",
                    "id": [
                        "s_1924"
                    ],
                    "type": "single",
                    "evidence": "present"
                },
                {
                    "question": "Have you been wheezing, i.e., making a continuous high-pitched whistling sound while breathing?",
                    "answer": "No",
                    "id": [
                        "s_474"
                    ],
                    "type": "single",
                    "evidence": "absent"
                }
            ],
            "chief_complaints": [
                "Headache",
                "Fever",
                "Cough"
            ],
            "secondary_complaints": [],
            "serious_symptoms": [
                {
                    "id": "s_1924",
                    "name": "Cough, paroxysmal",
                    "common_name": "Severe and sudden coughing attacks",
                    "is_emergency": false
                },
                {
                    "id": "s_104",
                    "name": "Cough, productive",
                    "common_name": "Coughing up phlegm",
                    "is_emergency": false
                }
            ],
            "possible_causes": [
                {
                    "id": "c_72",
                    "possible_cause": "Acute bronchitis",
                    "brief_summary": "Infection or inflammation of the bronchial tubes, usually producing cough and chest congestion",
                    "complete_summary": "Acute infection of the large airways may be caused by bacteria or viruses.  They also may become inflamed due to irritants such as smoke or caustic fumes.<br><br>The problem is usually self-limited and may last a few days to a week.  Depending on symptoms, your healthcare provider may prescribe antibiotics or anti-inflammatory medications.<br><br>If you are raising significant phlegm, a culture may be requested in the lab as a means of identifying whether there is a specific organism responsible.  This may allow for more targeted treatment with a specific antibiotic.",
                    "self_care_advice": "- Take medications prescribed by your healthcare provider and get plenty of rest.\r\n- Try to stay well-hydrated",
                    "see_provider": "Call your health care provider if you develop fever or shortness of breath, if your cough worsens, or if you cough any blood.  Additional testing may be warranted.",
                    "name": "Acute bronchitis",
                    "common_name": "Acute bronchitis",
                    "sex_filter": "both",
                    "categories": [
                        "Pulmonology"
                    ],
                    "prevalence": "moderate",
                    "acuteness": "acute",
                    "severity": "mild",
                    "extras": {
                        "icd10_code": "J20, J20.9, J68.0",
                        "hint": "If the symptoms are severe, or if they do not improve after 3 weeks, please consult a family doctor or a pulmonologist."
                    },
                    "triage_level": "self_care",
                    "recommended_channel": "personal_visit",
                    "probability": 0.492,
                    "explanationResponse": {
                        "type": "possibleCauseExplanationCard",
                        "header": "Why did I get this result?",
                        "text": "We used your responses from the symptom checker and your medical history to determine that Acute bronchitis could be the reason for your current symptoms.",
                        "reasonsForHeader": "Reasons for Acute bronchitis",
                        "reasonsAgainstHeader": "Reasons against Acute bronchitis",
                        "data": {
                            "supporting_evidence": [
                                "Coughing up phlegm",
                                "Fever lasting less than 3 days",
                                "Moderate headache",
                                "Cough lasting less than 3 weeks",
                                "Coughing up thick, yellow or green phlegm",
                                "Coughing up phlegm in the morning",
                                "Severe and sudden coughing attacks",
                                "Headache",
                                "Fever",
                                "Cough"
                            ],
                            "conflicting_evidence": [
                                "Sore throat",
                                "Nighttime cough",
                                "Whistling sound made while breathing",
                                "Fatigue",
                                "Chills",
                                "Muscle pain",
                                "Diminished appetite",
                                "Shortness of breath"
                            ],
                            "unconfirmed_evidence": []
                        }
                    },
                    "data_source": "CosmosDbSelfCareAdviceRepository",
                    "sources": [
                        "This information has been validated by the OptumCare clinical team."
                    ]
                },
                {
                    "id": "c_121",
                    "possible_cause": "Acute viral tonsillopharyngitis",
                    "brief_summary": "A viral infection that causes a sore throat.",
                    "complete_summary": "A sore throat is caused by an infection.  In adults, it is most commonly caused by a virus.<br><br>Other causes include- bacterial, fungus, dryness, irritants, GERD, allergies.<br><br>\r\nSymptoms:<br>\r\n- sore throat\r\n- chest congestion\r\n- post nasal drip\r\n- pain with swallowing\r\n- swollen, red tonsils\r\n- sneezing\r\n- body aches",
                    "self_care_advice": "Home remedies:<br>\r\n- drink water\r\n- rest\r\n- use a humidifier\r\n- gargle with saltwater\r\n- avoid irritants\r\n<br><br>\r\nA sore throat caused by a virus usually lasts five to seven days and doesn't require medical treatment.",
                    "see_provider": "Seek medical attention with any:\r\n- severe sore throat that lasts longer than a week\r\n- difficulty swallowing or breathing\r\n- inability to open mouth\r\n- persisting fever\r\n- Blood in your saliva or phlegm\r\n- Frequently recurring sore throats\r\n- A lump in your neck\r\n- Hoarseness lasting longer than 2 weeks",
                    "name": "Acute viral pharyngitis",
                    "common_name": "Acute viral throat infection",
                    "sex_filter": "both",
                    "categories": [
                        "Otorhinolaryngology"
                    ],
                    "prevalence": "common",
                    "acuteness": "acute",
                    "severity": "mild",
                    "extras": {
                        "icd10_code": "J02, J02.8, J02.9, J03.8, J03.9",
                        "hint": "If the symptoms worsen or do not improve in 1 to 2 days, please consult a family doctor."
                    },
                    "triage_level": "self_care",
                    "recommended_channel": "video_teleconsultation",
                    "probability": 0.2531,
                    "explanationResponse": {
                        "type": "possibleCauseExplanationCard",
                        "header": "Why did I get this result?",
                        "text": "We used your responses from the symptom checker and your medical history to determine that Acute viral throat infection could be the reason for your current symptoms.",
                        "reasonsForHeader": "Reasons for Acute viral throat infection",
                        "reasonsAgainstHeader": "Reasons against Acute viral throat infection",
                        "data": {
                            "supporting_evidence": [
                                "Coughing up phlegm",
                                "Fever lasting less than 3 days",
                                "Moderate headache",
                                "Cough lasting less than 3 weeks",
                                "Coughing up thick, yellow or green phlegm",
                                "Coughing up phlegm in the morning",
                                "Headache",
                                "Fever",
                                "Cough"
                            ],
                            "conflicting_evidence": [
                                "Sore throat",
                                "Nighttime cough",
                                "Fatigue",
                                "Chills",
                                "Muscle pain",
                                "Diminished appetite",
                                "Vomiting",
                                "Feeling sick or queasy",
                                "Shortness of breath",
                                "Excessive sweating"
                            ],
                            "unconfirmed_evidence": []
                        }
                    },
                    "data_source": "CosmosDbSelfCareAdviceRepository",
                    "sources": [
                        "This information has been validated by the OptumCare clinical team."
                    ]
                },
                {
                    "id": "c_1166",
                    "possible_cause": "Acute viral rhinosinusitis",
                    "brief_summary": "Acute viral rhinosinusitis is a common complication of viral upper respiratory tract infections ",
                    "complete_summary": "Acute sinusitis refers to sinusitis symptoms lasting less than four weeks. Most cases begin as a common cold. Symptoms often go away within a week to 10 days; but in some people, a bacterial infection develops.",
                    "self_care_advice": "Up to 70 % of people with acute sinusitis recover without any prescribed medications.  Other options for treatment include:<br>\r\n- Decongestants or nasal sprays might help relieve your symptoms and promote drainage of the infection.\r\n- Get plenty of rest, and keep your body hydrated by drinking several glasses of water a day.\r\n- Over-the-counter pain relievers such as aspirin, acetaminophen (Tylenol, others) or ibuprofen (Advil, Motrin, others) may be beneficial. Do NOT give aspirin to children under the age of 18.\r\n- In addition to medications, some people with sinusitis find relief by breathing hot, moist air, using hot packs or washing the nasal cavities with a saline rinse.",
                    "see_provider": "See a provider if your symptoms are not improving. ",
                    "name": "Acute viral rhinosinusitis",
                    "common_name": "Acute viral sinus infection",
                    "sex_filter": "both",
                    "categories": [
                        "Otorhinolaryngology"
                    ],
                    "prevalence": "moderate",
                    "acuteness": "acute",
                    "severity": "moderate",
                    "extras": {
                        "icd10_code": "J01, J01.0, J01.1, J01.2, J01.3, J01.4, J01.8, J01.9",
                        "hint": "Try to relieve the symptoms using over-the-counter medications. If the symptoms worsen, please consult a general practitioner."
                    },
                    "triage_level": "self_care",
                    "recommended_channel": "audio_teleconsultation",
                    "probability": 0.0768,
                    "data_source": "CosmosDbSelfCareAdviceRepository",
                    "sources": [
                        "This information has been validated by the OptumCare clinical team."
                    ]
                },
                {
                    "id": "c_130",
                    "possible_cause": "Acute otitis media",
                    "brief_summary": "Infection of the inner ear",
                    "complete_summary": "Inner ear infections are most commonly caused by bacterial or viral infections, typically following a recent upper respiratory infection or the common cold.<br><br>The onset of signs and symptoms of ear infection is usually quick, and may include:<br>\r\n- fever\r\n- ear pain\r\n- trouble sleeping\r\n- loss of appetite\r\n<br><br>\r\nRisk factors:<br>\r\n- young children\r\n- season changes or allergic rhinitis\r\n- poor air quality",
                    "self_care_advice": "Symptoms of ear infections usually improve within a few days, and most clear up on their own within 1-2 weeks without treatment.  However, otitis media may need to treated with antibiotics, which require medical evaluation.<br><br>Take over the counter pain medication as needed, such as Tylenol or Advil.",
                    "see_provider": "Seek medical care<br> \r\n- Symptoms last for more than a day\r\n- Ear pain is severe\r\n- You experience discharge of fluid, pus or bloody fluid from the ear ",
                    "name": "Acute otitis media",
                    "common_name": "Middle ear infection",
                    "sex_filter": "both",
                    "categories": [
                        "Otorhinolaryngology"
                    ],
                    "prevalence": "moderate",
                    "acuteness": "acute",
                    "severity": "moderate",
                    "extras": {
                        "icd10_code": "H66.0, H66.4, H66.9",
                        "hint": "Please consult a family doctor or an otolaryngologist."
                    },
                    "triage_level": "consultation",
                    "recommended_channel": "personal_visit",
                    "probability": 0.0653,
                    "data_source": "CosmosDbSelfCareAdviceRepository",
                    "sources": [
                        "This information has been validated by the OptumCare clinical team."
                    ]
                }
            ],
            "present_risk_factors": [],
            "care_options": [
                {
                    "cdoName": "OptumIncubator",
                    "triagelevel": "urgent_care",
                    "title": "Urgent Care",
                    "description": "We recommend that you **go to Urgent Care** for a walk-in appointment.",
                    "link": "Find an Urgent Care Location",
                    "href": "",
                    "aemTag": "UrgentCare"
                }
            ],
            "denials": [
                "Between 98.6 and 100.4°F or 37 and 38°C",
                "Between 100.4 and 104°F or 38 and 40°C",
                "More than 104°F or 40°C",
                "Dry cough, without phlegm or mucus",
                "Both a dry and wet cough, i.e., phlegm or mucus appearing occasionally throughout the day",
                "Between 3 and 8 weeks",
                "More than 8 weeks",
                "Cough, nocturnal",
                "Cough with blood or blood-stained mucus",
                "The mucus is pink and frothy",
                "Mild",
                "Severe",
                "Pharyngeal pain",
                "Wheezing, audible"
            ],
            "gender": "Female",
            "age": 65,
            "teleconsultation_applicable": false,
            "patient_comment": "N/A"
        },
        {
            "summaryCardContent": {
                "ageHeader": "Age",
                "careTypeHeader": "Please select the type of care you will seek",
                "recommendedHeaderText": "Recommended",
                "sexHeader": "Gender",
                "summaryText": "Below is a summary of the information we gathered from you and from your medical history.",
                "hasNoVirtualSlots": null,
                "tabHeaders": [
                    "Care Options",
                    "Summary"
                ],
                "summarySections": [
                    "Primary Symptoms",
                    "Other Symptoms",
                    "Pre-Existing Conditions",
                    "Demographics"
                ],
                "inPersonText": null
            },
            "possibleCausesContent": {
                "header": "Possible Causes",
                "instruction": "Expand a possible cause to learn more about symptoms and treatments",
                "noPossibleCauses": "We cannot identify possible causes based on your symptoms. Please consult with a doctor if you'd like to determine the possible cause or if your symptoms persist.",
                "resultReason": "Why did I get this result?",
                "sectionHeaders": [
                    "Overview",
                    "Self-Care Advice",
                    "When to see a Healthcare Provider",
                    "Sources"
                ]
            },
            "careOptionsData": {
                "careOptions": [
                    {
                        "displayText": "I will try self-care",
                        "type": "postBack",
                        "value": "SelfCare"
                    },
                    {
                        "displayText": "Contact me within two business days",
                        "type": "postBack",
                        "value": "ContactMe"
                    },
                    {
                        "displayText": "I will schedule a virtual care visit",
                        "type": "postBack",
                        "value": "VirtualCare"
                    },
                    {
                        "displayText": "I will schedule an in-person appointment",
                        "type": "postBack",
                        "value": "InPerson"
                    },
                    {
                        "displayText": "I will go to ReadyMED / urgent care",
                        "type": "postBack",
                        "value": "UrgentCare"
                    },
                    {
                        "displayText": "I will go to the emergency room",
                        "type": "postBack",
                        "value": "EmergencyRoom"
                    }
                ],
                "sectionHeader": "Please select the type of care you will seek",
                "showCareOptions": true
            }
        },
        {
            "triage_level": "consultation_24",
            "serious": [
                {
                    "id": "s_1924",
                    "name": "Cough, paroxysmal",
                    "common_name": "Severe and sudden coughing attacks",
                    "seriousness": "serious",
                    "is_emergency": false
                },
                {
                    "id": "s_104",
                    "name": "Cough, productive",
                    "common_name": "Coughing up phlegm",
                    "seriousness": "serious",
                    "is_emergency": false
                }
            ],
            "root_cause": "serious_evidence_present",
            "teleconsultation_applicable": false
        },
        {
            "type": "phoneNumberCard",
            "text": "Select a phone number below for our care team to reach you at:",
            "data": {
                "headerTexts": [
                    "What is your preferred contact method?",
                    "Select a phone number where our care team can reach you:",
                    "Enter your phone number below:",
                    "Can our care team leave a voice message at this phone number?"
                ],
                "contactMethods": [
                    "Message",
                    "Phone call"
                ],
                "phoneNumbers": [],
                "addNewText": "Add a new phone number",
                "yesNoButtons": [
                    "Yes",
                    "No"
                ],
                "cancelText": "Cancel",
                "backText": "Back",
                "nextText": "Next",
                "submitText": "Submit",
                "isMsgOkayText": "Yes to Voicemail",
                "isMsgNotOkayText": "No to Voicemail"
            }
        },
        {
            "EvidenceForValidation": [
                {
                    "commonName": "Headache",
                    "evidence": {
                        "id": "s_21",
                        "choice_id": "present",
                        "source": "initial"
                    }
                },
                {
                    "commonName": "Fever",
                    "evidence": {
                        "id": "s_98",
                        "choice_id": "present",
                        "source": "initial"
                    }
                },
                {
                    "commonName": "Cough",
                    "evidence": {
                        "id": "s_102",
                        "choice_id": "present",
                        "source": "initial"
                    }
                },
                {
                    "commonName": "Overweight and obesity",
                    "evidence": {
                        "id": "p_7",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Smoking cigarettes",
                    "evidence": {
                        "id": "p_28",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Recent physical injury",
                    "evidence": {
                        "id": "p_264",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "High cholesterol",
                    "evidence": {
                        "id": "p_10",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Diabetes",
                    "evidence": {
                        "choice_id": "absent",
                        "id": "p_8",
                        "source": "predefined"
                    }
                },
                {
                    "commonName": "Hypertension",
                    "evidence": {
                        "choice_id": "absent",
                        "id": "p_9",
                        "source": "predefined"
                    }
                },
                {
                    "commonName": "Depression",
                    "evidence": {
                        "choice_id": "absent",
                        "id": "p_171",
                        "source": "predefined"
                    }
                },
                {
                    "commonName": "Asthma",
                    "evidence": {
                        "choice_id": "absent",
                        "id": "p_167",
                        "source": "predefined"
                    }
                },
                {
                    "commonName": "Fatigue",
                    "evidence": {
                        "id": "s_2100",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Chills",
                    "evidence": {
                        "id": "s_81",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Muscle pain",
                    "evidence": {
                        "id": "s_1142",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Diminished appetite",
                    "evidence": {
                        "id": "s_284",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Vomiting",
                    "evidence": {
                        "id": "s_305",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Feeling sick or queasy",
                    "evidence": {
                        "id": "s_156",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Shortness of breath",
                    "evidence": {
                        "id": "s_88",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Excessive sweating",
                    "evidence": {
                        "id": "s_216",
                        "choice_id": "absent",
                        "source": "suggest"
                    }
                },
                {
                    "commonName": "Between 98.6 and 100.4°F or 37 and 38°C",
                    "evidence": {
                        "id": "s_99",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Between 100.4 and 104°F or 38 and 40°C",
                    "evidence": {
                        "id": "s_100",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "More than 104°F or 40°C",
                    "evidence": {
                        "id": "s_2000",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "It wasn't measured",
                    "evidence": {
                        "id": "s_1820",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Dry cough, without phlegm or mucus",
                    "evidence": {
                        "id": "s_105",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Wet cough, with phlegm or mucus",
                    "evidence": {
                        "id": "s_104",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Both a dry and wet cough, i.e., phlegm or mucus appearing occasionally throughout the day",
                    "evidence": {
                        "id": "s_2268",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Cough with blood or blood-stained mucus",
                    "evidence": {
                        "id": "s_116",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "The mucus is thick and yellow or green",
                    "evidence": {
                        "id": "s_526",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "The mucus is pink and frothy",
                    "evidence": {
                        "id": "s_670",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Often comes in the morning",
                    "evidence": {
                        "id": "s_662",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Less than 3 days",
                    "evidence": {
                        "id": "s_2319",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Between 3 and 7 days",
                    "evidence": {
                        "id": "s_2320",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "More than 7 days",
                    "evidence": {
                        "id": "s_2321",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Mild",
                    "evidence": {
                        "id": "s_1780",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Moderate",
                    "evidence": {
                        "id": "s_1781",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Severe",
                    "evidence": {
                        "id": "s_1193",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Less than 3 weeks",
                    "evidence": {
                        "id": "s_103",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Between 3 and 8 weeks",
                    "evidence": {
                        "id": "s_1858",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "More than 8 weeks",
                    "evidence": {
                        "id": "s_106",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Pharyngeal pain",
                    "evidence": {
                        "id": "s_20",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Cough, nocturnal",
                    "evidence": {
                        "id": "s_1985",
                        "choice_id": "absent"
                    }
                },
                {
                    "commonName": "Cough, paroxysmal",
                    "evidence": {
                        "id": "s_1924",
                        "choice_id": "present"
                    }
                },
                {
                    "commonName": "Audible wheezing",
                    "evidence": {
                        "id": "s_474",
                        "choice_id": "absent"
                    }
                }
            ]
        },
        {
            "hpiSoapNote": {
                "hpiObject": [
                    {
                        "symptom": "Fever",
                        "positive": [
                            "It wasn't measured"
                        ],
                        "negative": [
                            "Between 98.6 and 100.4°F or 37 and 38°C",
                            "Between 100.4 and 104°F or 38 and 40°C",
                            "More than 104°F or 40°C"
                        ]
                    },
                    {
                        "symptom": "Cough",
                        "positive": [
                            "Wet cough, with phlegm or mucus",
                            "Less than 3 weeks",
                            "Cough, paroxysmal"
                        ],
                        "negative": [
                            "Dry cough, without phlegm or mucus",
                            "Both a dry and wet cough, i.e., phlegm or mucus appearing occasionally throughout the day",
                            "Between 3 and 8 weeks",
                            "More than 8 weeks",
                            "Cough, nocturnal"
                        ]
                    },
                    {
                        "symptom": "Coughing up blood",
                        "positive": [],
                        "negative": [
                            "Cough with blood or blood-stained mucus"
                        ]
                    },
                    {
                        "symptom": "Coughing up phlegm",
                        "positive": [
                            "The mucus is thick and yellow or green",
                            "Often comes in the morning"
                        ],
                        "negative": [
                            "The mucus is pink and frothy"
                        ]
                    },
                    {
                        "symptom": "Headache",
                        "positive": [
                            "Moderate"
                        ],
                        "negative": [
                            "Mild",
                            "Severe"
                        ]
                    },
                    {
                        "symptom": "Sore throat",
                        "positive": [],
                        "negative": [
                            "Pharyngeal pain"
                        ]
                    },
                    {
                        "symptom": "Whistling sound made while breathing",
                        "positive": [],
                        "negative": [
                            "Wheezing, audible"
                        ]
                    }
                ]
            }
        },
        {
            "fhirTriageLoadData": {
                "triage_level": "urgent_care",
                "qna": [
                    {
                        "question": "What is your body temperature?",
                        "answer": "It wasn't measured",
                        "id": [
                            "s_1820"
                        ],
                        "type": "group_single",
                        "evidence": "present"
                    },
                    {
                        "question": "How would you describe the cough?",
                        "answer": "Wet cough, with phlegm or mucus",
                        "id": [
                            "s_104"
                        ],
                        "type": "group_single",
                        "evidence": "present"
                    },
                    {
                        "question": "How would you describe the wet cough?",
                        "answer": "The mucus is thick and yellow or green",
                        "id": [
                            "s_526"
                        ],
                        "type": "group_multiple",
                        "evidence": "present"
                    },
                    {
                        "question": "How would you describe the wet cough?",
                        "answer": "The mucus is pink and frothy",
                        "id": [
                            "s_670"
                        ],
                        "type": "group_multiple",
                        "evidence": "absent"
                    },
                    {
                        "question": "How would you describe the wet cough?",
                        "answer": "Often comes in the morning",
                        "id": [
                            "s_662"
                        ],
                        "type": "group_multiple",
                        "evidence": "present"
                    },
                    {
                        "question": "How long have you had a fever?",
                        "answer": "Less than 3 days",
                        "id": [
                            "s_2319"
                        ],
                        "type": "group_single",
                        "evidence": "present"
                    },
                    {
                        "question": "How strong is the headache?",
                        "answer": "Moderate",
                        "id": [
                            "s_1781"
                        ],
                        "type": "group_single",
                        "evidence": "present"
                    },
                    {
                        "question": "How long have you had a cough?",
                        "answer": "Less than 3 weeks",
                        "id": [
                            "s_103"
                        ],
                        "type": "group_single",
                        "evidence": "present"
                    },
                    {
                        "question": "Do you have a sore throat?",
                        "answer": "No",
                        "id": [
                            "s_20"
                        ],
                        "type": "single",
                        "evidence": "absent"
                    },
                    {
                        "question": "Do you have a cough during the night that sometimes wakes you up?",
                        "answer": "No",
                        "id": [
                            "s_1985"
                        ],
                        "type": "single",
                        "evidence": "absent"
                    },
                    {
                        "question": "Do you have intermittent attacks of uncontrollable, violent coughing, making it hard to breathe?",
                        "answer": "Yes",
                        "id": [
                            "s_1924"
                        ],
                        "type": "single",
                        "evidence": "present"
                    },
                    {
                        "question": "Have you been wheezing, i.e., making a continuous high-pitched whistling sound while breathing?",
                        "answer": "No",
                        "id": [
                            "s_474"
                        ],
                        "type": "single",
                        "evidence": "absent"
                    }
                ],
                "chief_complaints": [
                    "Headache",
                    "Fever",
                    "Cough"
                ],
                "secondary_complaints": [],
                "serious_symptoms": [
                    {
                        "id": "s_1924",
                        "name": "Cough, paroxysmal",
                        "common_name": "Severe and sudden coughing attacks",
                        "is_emergency": false
                    },
                    {
                        "id": "s_104",
                        "name": "Cough, productive",
                        "common_name": "Coughing up phlegm",
                        "is_emergency": false
                    }
                ],
                "possible_causes": [
                    {
                        "id": "c_72",
                        "name": "Acute bronchitis",
                        "common_name": "Acute bronchitis",
                        "sex_filter": "both",
                        "categories": [
                            "Pulmonology"
                        ],
                        "prevalence": "moderate",
                        "acuteness": "acute",
                        "severity": "mild",
                        "extras": {
                            "icd10_code": "J20, J20.9, J68.0",
                            "hint": "If the symptoms are severe, or if they do not improve after 3 weeks, please consult a family doctor or a pulmonologist."
                        },
                        "triage_level": "self_care",
                        "recommended_channel": "personal_visit",
                        "possible_cause": "Acute bronchitis",
                        "brief_summary": "Infection or inflammation of the bronchial tubes, usually producing cough and chest congestion",
                        "complete_summary": "Acute infection of the large airways may be caused by bacteria or viruses.  They also may become inflamed due to irritants such as smoke or caustic fumes.<br><br>The problem is usually self-limited and may last a few days to a week.  Depending on symptoms, your healthcare provider may prescribe antibiotics or anti-inflammatory medications.<br><br>If you are raising significant phlegm, a culture may be requested in the lab as a means of identifying whether there is a specific organism responsible.  This may allow for more targeted treatment with a specific antibiotic.",
                        "self_care_advice": "- Take medications prescribed by your healthcare provider and get plenty of rest.\r\n- Try to stay well-hydrated",
                        "see_provider": "Call your health care provider if you develop fever or shortness of breath, if your cough worsens, or if you cough any blood.  Additional testing may be warranted.",
                        "probability": 0.492,
                        "data_source": "CosmosDbSelfCareAdviceRepository",
                        "sources": [],
                        "explanation": {
                            "supporting_evidence": [
                                "Coughing up phlegm",
                                "Fever lasting less than 3 days",
                                "Moderate headache",
                                "Cough lasting less than 3 weeks",
                                "Coughing up thick, yellow or green phlegm",
                                "Coughing up phlegm in the morning",
                                "Severe and sudden coughing attacks",
                                "Headache",
                                "Fever",
                                "Cough"
                            ],
                            "conflicting_evidence": [
                                "Sore throat",
                                "Nighttime cough",
                                "Whistling sound made while breathing",
                                "Fatigue",
                                "Chills",
                                "Muscle pain",
                                "Diminished appetite",
                                "Shortness of breath"
                            ],
                            "unconfirmed_evidence": []
                        }
                    },
                    {
                        "id": "c_121",
                        "name": "Acute viral pharyngitis",
                        "common_name": "Acute viral throat infection",
                        "sex_filter": "both",
                        "categories": [
                            "Otorhinolaryngology"
                        ],
                        "prevalence": "common",
                        "acuteness": "acute",
                        "severity": "mild",
                        "extras": {
                            "icd10_code": "J02, J02.8, J02.9, J03.8, J03.9",
                            "hint": "If the symptoms worsen or do not improve in 1 to 2 days, please consult a family doctor."
                        },
                        "triage_level": "self_care",
                        "recommended_channel": "video_teleconsultation",
                        "possible_cause": "Acute viral tonsillopharyngitis",
                        "brief_summary": "A viral infection that causes a sore throat.",
                        "complete_summary": "A sore throat is caused by an infection.  In adults, it is most commonly caused by a virus.<br><br>Other causes include- bacterial, fungus, dryness, irritants, GERD, allergies.<br><br>\r\nSymptoms:<br>\r\n- sore throat\r\n- chest congestion\r\n- post nasal drip\r\n- pain with swallowing\r\n- swollen, red tonsils\r\n- sneezing\r\n- body aches",
                        "self_care_advice": "Home remedies:<br>\r\n- drink water\r\n- rest\r\n- use a humidifier\r\n- gargle with saltwater\r\n- avoid irritants\r\n<br><br>\r\nA sore throat caused by a virus usually lasts five to seven days and doesn't require medical treatment.",
                        "see_provider": "Seek medical attention with any:\r\n- severe sore throat that lasts longer than a week\r\n- difficulty swallowing or breathing\r\n- inability to open mouth\r\n- persisting fever\r\n- Blood in your saliva or phlegm\r\n- Frequently recurring sore throats\r\n- A lump in your neck\r\n- Hoarseness lasting longer than 2 weeks",
                        "probability": 0.2531,
                        "data_source": "CosmosDbSelfCareAdviceRepository",
                        "sources": [],
                        "explanation": {
                            "supporting_evidence": [
                                "Coughing up phlegm",
                                "Fever lasting less than 3 days",
                                "Moderate headache",
                                "Cough lasting less than 3 weeks",
                                "Coughing up thick, yellow or green phlegm",
                                "Coughing up phlegm in the morning",
                                "Headache",
                                "Fever",
                                "Cough"
                            ],
                            "conflicting_evidence": [
                                "Sore throat",
                                "Nighttime cough",
                                "Fatigue",
                                "Chills",
                                "Muscle pain",
                                "Diminished appetite",
                                "Vomiting",
                                "Feeling sick or queasy",
                                "Shortness of breath",
                                "Excessive sweating"
                            ],
                            "unconfirmed_evidence": []
                        }
                    },
                    {
                        "id": "c_1166",
                        "name": "Acute viral rhinosinusitis",
                        "common_name": "Acute viral sinus infection",
                        "sex_filter": "both",
                        "categories": [
                            "Otorhinolaryngology"
                        ],
                        "prevalence": "moderate",
                        "acuteness": "acute",
                        "severity": "moderate",
                        "extras": {
                            "icd10_code": "J01, J01.0, J01.1, J01.2, J01.3, J01.4, J01.8, J01.9",
                            "hint": "Try to relieve the symptoms using over-the-counter medications. If the symptoms worsen, please consult a general practitioner."
                        },
                        "triage_level": "self_care",
                        "recommended_channel": "audio_teleconsultation",
                        "possible_cause": "Acute viral rhinosinusitis",
                        "brief_summary": "Acute viral rhinosinusitis is a common complication of viral upper respiratory tract infections ",
                        "complete_summary": "Acute sinusitis refers to sinusitis symptoms lasting less than four weeks. Most cases begin as a common cold. Symptoms often go away within a week to 10 days; but in some people, a bacterial infection develops.",
                        "self_care_advice": "Up to 70 % of people with acute sinusitis recover without any prescribed medications.  Other options for treatment include:<br>\r\n- Decongestants or nasal sprays might help relieve your symptoms and promote drainage of the infection.\r\n- Get plenty of rest, and keep your body hydrated by drinking several glasses of water a day.\r\n- Over-the-counter pain relievers such as aspirin, acetaminophen (Tylenol, others) or ibuprofen (Advil, Motrin, others) may be beneficial. Do NOT give aspirin to children under the age of 18.\r\n- In addition to medications, some people with sinusitis find relief by breathing hot, moist air, using hot packs or washing the nasal cavities with a saline rinse.",
                        "see_provider": "See a provider if your symptoms are not improving. ",
                        "probability": 0.0768,
                        "data_source": "CosmosDbSelfCareAdviceRepository",
                        "sources": [],
                        "explanation": null
                    },
                    {
                        "id": "c_130",
                        "name": "Acute otitis media",
                        "common_name": "Middle ear infection",
                        "sex_filter": "both",
                        "categories": [
                            "Otorhinolaryngology"
                        ],
                        "prevalence": "moderate",
                        "acuteness": "acute",
                        "severity": "moderate",
                        "extras": {
                            "icd10_code": "H66.0, H66.4, H66.9",
                            "hint": "Please consult a family doctor or an otolaryngologist."
                        },
                        "triage_level": "consultation",
                        "recommended_channel": "personal_visit",
                        "possible_cause": "Acute otitis media",
                        "brief_summary": "Infection of the inner ear",
                        "complete_summary": "Inner ear infections are most commonly caused by bacterial or viral infections, typically following a recent upper respiratory infection or the common cold.<br><br>The onset of signs and symptoms of ear infection is usually quick, and may include:<br>\r\n- fever\r\n- ear pain\r\n- trouble sleeping\r\n- loss of appetite\r\n<br><br>\r\nRisk factors:<br>\r\n- young children\r\n- season changes or allergic rhinitis\r\n- poor air quality",
                        "self_care_advice": "Symptoms of ear infections usually improve within a few days, and most clear up on their own within 1-2 weeks without treatment.  However, otitis media may need to treated with antibiotics, which require medical evaluation.<br><br>Take over the counter pain medication as needed, such as Tylenol or Advil.",
                        "see_provider": "Seek medical care<br> \r\n- Symptoms last for more than a day\r\n- Ear pain is severe\r\n- You experience discharge of fluid, pus or bloody fluid from the ear ",
                        "probability": 0.0653,
                        "data_source": "CosmosDbSelfCareAdviceRepository",
                        "sources": [],
                        "explanation": null
                    }
                ],
                "present_risk_factors": [],
                "care_options": [
                    "{\"cdoName\":\"OptumIncubator\",\"triagelevel\":\"urgent_care\",\"title\":\"Urgent Care\",\"description\":\"We recommend that you **go to Urgent Care** for a walk-in appointment.\",\"link\":\"Find an Urgent Care Location\",\"href\":\"\",\"aemTag\":\"UrgentCare\"}"
                ],
                "denials": [
                    "Between 98.6 and 100.4°F or 37 and 38°C",
                    "Between 100.4 and 104°F or 38 and 40°C",
                    "More than 104°F or 40°C",
                    "Dry cough, without phlegm or mucus",
                    "Both a dry and wet cough, i.e., phlegm or mucus appearing occasionally throughout the day",
                    "Between 3 and 8 weeks",
                    "More than 8 weeks",
                    "Cough, nocturnal",
                    "Cough with blood or blood-stained mucus",
                    "The mucus is pink and frothy",
                    "Mild",
                    "Severe",
                    "Pharyngeal pain",
                    "Wheezing, audible"
                ],
                "gender": "Female",
                "age": 65,
                "teleconsultation_applicable": false,
                "patient_comment": "N/A"
            }
        },
        {
            "HpiQnaAnswers": [
                {
                    "id": [
                        "s_1820"
                    ],
                    "question": "What is your body temperature?",
                    "answer": "It wasn't measured",
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "id": [
                        "s_104"
                    ],
                    "question": "How would you describe the cough?",
                    "answer": "Wet cough, with phlegm or mucus",
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "id": [
                        "s_526"
                    ],
                    "answer": "The mucus is thick and yellow or green",
                    "type": "group_multiple",
                    "evidence": "present",
                    "question": "How would you describe the wet cough?"
                },
                {
                    "id": [
                        "s_670"
                    ],
                    "answer": "The mucus is pink and frothy",
                    "type": "group_multiple",
                    "evidence": "absent",
                    "question": "How would you describe the wet cough?"
                },
                {
                    "id": [
                        "s_662"
                    ],
                    "answer": "Often comes in the morning",
                    "type": "group_multiple",
                    "evidence": "present",
                    "question": "How would you describe the wet cough?"
                },
                {
                    "id": [
                        "s_2319"
                    ],
                    "question": "How long have you had a fever?",
                    "answer": "Less than 3 days",
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "id": [
                        "s_1781"
                    ],
                    "question": "How strong is the headache?",
                    "answer": "Moderate",
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "id": [
                        "s_103"
                    ],
                    "question": "How long have you had a cough?",
                    "answer": "Less than 3 weeks",
                    "type": "group_single",
                    "evidence": "present"
                },
                {
                    "id": [
                        "s_20"
                    ],
                    "question": "Do you have a sore throat?",
                    "answer": "No",
                    "type": "single",
                    "evidence": "absent"
                },
                {
                    "id": [
                        "s_1985"
                    ],
                    "question": "Do you have a cough during the night that sometimes wakes you up?",
                    "answer": "No",
                    "type": "single",
                    "evidence": "absent"
                },
                {
                    "id": [
                        "s_1924"
                    ],
                    "question": "Do you have intermittent attacks of uncontrollable, violent coughing, making it hard to breathe?",
                    "answer": "Yes",
                    "type": "single",
                    "evidence": "present"
                },
                {
                    "id": [
                        "s_474"
                    ],
                    "question": "Have you been wheezing, i.e., making a continuous high-pitched whistling sound while breathing?",
                    "answer": "No",
                    "type": "single",
                    "evidence": "absent"
                }
            ]
        }
    ],
    "id": 41
}

export const urgentCareMessage = {
    "AsyncHBID": "bc9d0720-6f92-11ee-a42b-511da3c34d8b",
    "attachments": {
        "images": []
    },
    "buttons": [],
    "data": [
        {
            "current_step": "scheduleappointment",
            "question_id": "CONFIRMATION",
            "version": "2.8.0.23",
            "cdoName": "OptumIncubator",
            "headerText": "**Thank you for selecting urgent care**",
            "subHeaderText": "Please visit an urgent care location within the next 24 hours."
        },
        {
            "urgentCareLocationLinkText": "View our urgent care locations",
            "urgentCareLocationDisclaimerText": "Please note that hours and services may differ due to holidays and site closures.",
            "urgentCareLocationLinkContent": {
                "header": "Urgent care locations",
                "locations": [
                    {
                        "address": [
                            "608 E 13th Ave"
                        ],
                        "city": "Denver",
                        "hours": [
                            "M, W-F: 7:30 a.m. to 7 p.m.",
                            "Tu: 9 a.m. to 3 p.m.",
                            "Sa-Su: 8 a.m. to 5 p.m."
                        ],
                        "name": "Your Mom's House",
                        "phone": "425-339-5422",
                        "state": "Colorado",
                        "zip": "80203",
                        "getDirectionsText": "[Get Directions](https://www.google.com/maps/dir/?api=1&destination=Your+Mom%27s+House%2C+608+E+13th+Ave%2C+Denver%2C+Colorado+80203&&travel_mode=driving)"
                    }
                ]
            }
        },
        {
            "showCheckMark": false,
            "sideBarColor": "#2E853F"
        }
    ],
    "hostName": "InstanceIdNotSet",
    "hyperlinks": [],
    "text": "",
    "type": "confirmation"
}